///Slick js core Start
!(function (i) {
    "use strict";
    "function" == typeof define && define.amd
        ? define(["jquery"], i)
        : "undefined" != typeof exports
        ? (module.exports = i(require("jquery")))
        : i(jQuery);
})(function (i) {
    "use strict";
    var e = window.Slick || {};
    ((e = (function () {
        var e = 0;
        return function (t, o) {
            var s,
                n = this;
            (n.defaults = {
                accessibility: !0,
                adaptiveHeight: !1,
                appendArrows: i(t),
                appendDots: i(t),
                arrows: !0,
                asNavFor: null,
                prevArrow:
                    '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
                nextArrow:
                    '<button class="slick-next" aria-label="Next" type="button">Next</button>',
                autoplay: !1,
                autoplaySpeed: 3e3,
                centerMode: !1,
                centerPadding: "50px",
                cssEase: "ease",
                customPaging: function (e, t) {
                    return i('<button type="button" />').text(t + 1);
                },
                dots: !1,
                dotsClass: "slick-dots",
                draggable: !0,
                easing: "linear",
                edgeFriction: 0.35,
                fade: !1,
                focusOnSelect: !1,
                focusOnChange: !1,
                infinite: !0,
                initialSlide: 0,
                lazyLoad: "ondemand",
                mobileFirst: !1,
                pauseOnHover: !0,
                pauseOnFocus: !0,
                pauseOnDotsHover: !1,
                respondTo: "window",
                responsive: null,
                rows: 1,
                rtl: !1,
                slide: "",
                slidesPerRow: 1,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                swipe: !0,
                swipeToSlide: !1,
                touchMove: !0,
                touchThreshold: 5,
                useCSS: !0,
                useTransform: !0,
                variableWidth: !1,
                vertical: !1,
                verticalSwiping: !1,
                waitForAnimate: !0,
                zIndex: 1e3,
            }),
                (n.initials = {
                    animating: !1,
                    dragging: !1,
                    autoPlayTimer: null,
                    currentDirection: 0,
                    currentLeft: null,
                    currentSlide: 0,
                    direction: 1,
                    $dots: null,
                    listWidth: null,
                    listHeight: null,
                    loadIndex: 0,
                    $nextArrow: null,
                    $prevArrow: null,
                    scrolling: !1,
                    slideCount: null,
                    slideWidth: null,
                    $slideTrack: null,
                    $slides: null,
                    sliding: !1,
                    slideOffset: 0,
                    swipeLeft: null,
                    swiping: !1,
                    $list: null,
                    touchObject: {},
                    transformsEnabled: !1,
                    unslicked: !1,
                }),
                i.extend(n, n.initials),
                (n.activeBreakpoint = null),
                (n.animType = null),
                (n.animProp = null),
                (n.breakpoints = []),
                (n.breakpointSettings = []),
                (n.cssTransitions = !1),
                (n.focussed = !1),
                (n.interrupted = !1),
                (n.hidden = "hidden"),
                (n.paused = !0),
                (n.positionProp = null),
                (n.respondTo = null),
                (n.rowCount = 1),
                (n.shouldClick = !0),
                (n.$slider = i(t)),
                (n.$slidesCache = null),
                (n.transformType = null),
                (n.transitionType = null),
                (n.visibilityChange = "visibilitychange"),
                (n.windowWidth = 0),
                (n.windowTimer = null),
                (s = i(t).data("slick") || {}),
                (n.options = i.extend({}, n.defaults, o, s)),
                (n.currentSlide = n.options.initialSlide),
                (n.originalSettings = n.options),
                void 0 !== document.mozHidden
                    ? ((n.hidden = "mozHidden"),
                      (n.visibilityChange = "mozvisibilitychange"))
                    : void 0 !== document.webkitHidden &&
                      ((n.hidden = "webkitHidden"),
                      (n.visibilityChange = "webkitvisibilitychange")),
                (n.autoPlay = i.proxy(n.autoPlay, n)),
                (n.autoPlayClear = i.proxy(n.autoPlayClear, n)),
                (n.autoPlayIterator = i.proxy(n.autoPlayIterator, n)),
                (n.changeSlide = i.proxy(n.changeSlide, n)),
                (n.clickHandler = i.proxy(n.clickHandler, n)),
                (n.selectHandler = i.proxy(n.selectHandler, n)),
                (n.setPosition = i.proxy(n.setPosition, n)),
                (n.swipeHandler = i.proxy(n.swipeHandler, n)),
                (n.dragHandler = i.proxy(n.dragHandler, n)),
                (n.keyHandler = i.proxy(n.keyHandler, n)),
                (n.instanceUid = e++),
                (n.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/),
                n.registerBreakpoints(),
                n.init(!0);
        };
    })()).prototype.activateADA = function () {
        this.$slideTrack
            .find(".slick-active")
            .attr({ "aria-hidden": "false" })
            .find("a, input, button, select")
            .attr({ tabindex: "0" });
    }),
        (e.prototype.addSlide = e.prototype.slickAdd =
            function (e, t, o) {
                var s = this;
                if ("boolean" == typeof t) (o = t), (t = null);
                else if (t < 0 || t >= s.slideCount) return !1;
                s.unload(),
                    "number" == typeof t
                        ? 0 === t && 0 === s.$slides.length
                            ? i(e).appendTo(s.$slideTrack)
                            : o
                            ? i(e).insertBefore(s.$slides.eq(t))
                            : i(e).insertAfter(s.$slides.eq(t))
                        : !0 === o
                        ? i(e).prependTo(s.$slideTrack)
                        : i(e).appendTo(s.$slideTrack),
                    (s.$slides = s.$slideTrack.children(this.options.slide)),
                    s.$slideTrack.children(this.options.slide).detach(),
                    s.$slideTrack.append(s.$slides),
                    s.$slides.each(function (e, t) {
                        i(t).attr("data-slick-index", e);
                    }),
                    (s.$slidesCache = s.$slides),
                    s.reinit();
            }),
        (e.prototype.animateHeight = function () {
            var i = this;
            if (
                1 === i.options.slidesToShow &&
                !0 === i.options.adaptiveHeight &&
                !1 === i.options.vertical
            ) {
                var e = i.$slides.eq(i.currentSlide).outerHeight(!0);
                i.$list.animate({ height: e }, i.options.speed);
            }
        }),
        (e.prototype.animateSlide = function (e, t) {
            var o = {},
                s = this;
            s.animateHeight(),
                !0 === s.options.rtl && !1 === s.options.vertical && (e = -e),
                !1 === s.transformsEnabled
                    ? !1 === s.options.vertical
                        ? s.$slideTrack.animate(
                              { left: e },
                              s.options.speed,
                              s.options.easing,
                              t
                          )
                        : s.$slideTrack.animate(
                              { top: e },
                              s.options.speed,
                              s.options.easing,
                              t
                          )
                    : !1 === s.cssTransitions
                    ? (!0 === s.options.rtl && (s.currentLeft = -s.currentLeft),
                      i({ animStart: s.currentLeft }).animate(
                          { animStart: e },
                          {
                              duration: s.options.speed,
                              easing: s.options.easing,
                              step: function (i) {
                                  (i = Math.ceil(i)),
                                      !1 === s.options.vertical
                                          ? ((o[s.animType] =
                                                "translate(" + i + "px, 0px)"),
                                            s.$slideTrack.css(o))
                                          : ((o[s.animType] =
                                                "translate(0px," + i + "px)"),
                                            s.$slideTrack.css(o));
                              },
                              complete: function () {
                                  t && t.call();
                              },
                          }
                      ))
                    : (s.applyTransition(),
                      (e = Math.ceil(e)),
                      !1 === s.options.vertical
                          ? (o[s.animType] =
                                "translate3d(" + e + "px, 0px, 0px)")
                          : (o[s.animType] =
                                "translate3d(0px," + e + "px, 0px)"),
                      s.$slideTrack.css(o),
                      t &&
                          setTimeout(function () {
                              s.disableTransition(), t.call();
                          }, s.options.speed));
        }),
        (e.prototype.getNavTarget = function () {
            var e = this,
                t = e.options.asNavFor;
            return t && null !== t && (t = i(t).not(e.$slider)), t;
        }),
        (e.prototype.asNavFor = function (e) {
            var t = this.getNavTarget();
            null !== t &&
                "object" == typeof t &&
                t.each(function () {
                    var t = i(this).slick("getSlick");
                    t.unslicked || t.slideHandler(e, !0);
                });
        }),
        (e.prototype.applyTransition = function (i) {
            var e = this,
                t = {};
            !1 === e.options.fade
                ? (t[e.transitionType] =
                      e.transformType +
                      " " +
                      e.options.speed +
                      "ms " +
                      e.options.cssEase)
                : (t[e.transitionType] =
                      "opacity " + e.options.speed + "ms " + e.options.cssEase),
                !1 === e.options.fade
                    ? e.$slideTrack.css(t)
                    : e.$slides.eq(i).css(t);
        }),
        (e.prototype.autoPlay = function () {
            var i = this;
            i.autoPlayClear(),
                i.slideCount > i.options.slidesToShow &&
                    (i.autoPlayTimer = setInterval(
                        i.autoPlayIterator,
                        i.options.autoplaySpeed
                    ));
        }),
        (e.prototype.autoPlayClear = function () {
            var i = this;
            i.autoPlayTimer && clearInterval(i.autoPlayTimer);
        }),
        (e.prototype.autoPlayIterator = function () {
            var i = this,
                e = i.currentSlide + i.options.slidesToScroll;
            i.paused ||
                i.interrupted ||
                i.focussed ||
                (!1 === i.options.infinite &&
                    (1 === i.direction &&
                    i.currentSlide + 1 === i.slideCount - 1
                        ? (i.direction = 0)
                        : 0 === i.direction &&
                          ((e = i.currentSlide - i.options.slidesToScroll),
                          i.currentSlide - 1 == 0 && (i.direction = 1))),
                i.slideHandler(e));
        }),
        (e.prototype.buildArrows = function () {
            var e = this;
            !0 === e.options.arrows &&
                ((e.$prevArrow = i(e.options.prevArrow).addClass(
                    "slick-arrow"
                )),
                (e.$nextArrow = i(e.options.nextArrow).addClass("slick-arrow")),
                e.slideCount > e.options.slidesToShow
                    ? (e.$prevArrow
                          .removeClass("slick-hidden")
                          .removeAttr("aria-hidden tabindex"),
                      e.$nextArrow
                          .removeClass("slick-hidden")
                          .removeAttr("aria-hidden tabindex"),
                      e.htmlExpr.test(e.options.prevArrow) &&
                          e.$prevArrow.prependTo(e.options.appendArrows),
                      e.htmlExpr.test(e.options.nextArrow) &&
                          e.$nextArrow.appendTo(e.options.appendArrows),
                      !0 !== e.options.infinite &&
                          e.$prevArrow
                              .addClass("slick-disabled")
                              .attr("aria-disabled", "true"))
                    : e.$prevArrow
                          .add(e.$nextArrow)
                          .addClass("slick-hidden")
                          .attr({ "aria-disabled": "true", tabindex: "-1" }));
        }),
        (e.prototype.buildDots = function () {
            var e,
                t,
                o = this;
            if (!0 === o.options.dots) {
                for (
                    o.$slider.addClass("slick-dotted"),
                        t = i("<ul />").addClass(o.options.dotsClass),
                        e = 0;
                    e <= o.getDotCount();
                    e += 1
                )
                    t.append(
                        i("<li />").append(
                            o.options.customPaging.call(this, o, e)
                        )
                    );
                (o.$dots = t.appendTo(o.options.appendDots)),
                    o.$dots.find("li").first().addClass("slick-active");
            }
        }),
        (e.prototype.buildOut = function () {
            var e = this;
            (e.$slides = e.$slider
                .children(e.options.slide + ":not(.slick-cloned)")
                .addClass("slick-slide")),
                (e.slideCount = e.$slides.length),
                e.$slides.each(function (e, t) {
                    i(t)
                        .attr("data-slick-index", e)
                        .data("originalStyling", i(t).attr("style") || "");
                }),
                e.$slider.addClass("slick-slider"),
                (e.$slideTrack =
                    0 === e.slideCount
                        ? i('<div class="slick-track"/>').appendTo(e.$slider)
                        : e.$slides
                              .wrapAll('<div class="slick-track"/>')
                              .parent()),
                (e.$list = e.$slideTrack
                    .wrap('<div class="slick-list"/>')
                    .parent()),
                e.$slideTrack.css("opacity", 0),
                (!0 !== e.options.centerMode &&
                    !0 !== e.options.swipeToSlide) ||
                    (e.options.slidesToScroll = 1),
                i("img[data-lazy]", e.$slider)
                    .not("[src]")
                    .addClass("slick-loading"),
                e.setupInfinite(),
                e.buildArrows(),
                e.buildDots(),
                e.updateDots(),
                e.setSlideClasses(
                    "number" == typeof e.currentSlide ? e.currentSlide : 0
                ),
                !0 === e.options.draggable && e.$list.addClass("draggable");
        }),
        (e.prototype.buildRows = function () {
            var i,
                e,
                t,
                o,
                s,
                n,
                r,
                l = this;
            if (
                ((o = document.createDocumentFragment()),
                (n = l.$slider.children()),
                l.options.rows > 1)
            ) {
                for (
                    r = l.options.slidesPerRow * l.options.rows,
                        s = Math.ceil(n.length / r),
                        i = 0;
                    i < s;
                    i++
                ) {
                    var d = document.createElement("div");
                    for (e = 0; e < l.options.rows; e++) {
                        var a = document.createElement("div");
                        for (t = 0; t < l.options.slidesPerRow; t++) {
                            var c = i * r + (e * l.options.slidesPerRow + t);
                            n.get(c) && a.appendChild(n.get(c));
                        }
                        d.appendChild(a);
                    }
                    o.appendChild(d);
                }
                l.$slider.empty().append(o),
                    l.$slider
                        .children()
                        .children()
                        .children()
                        .css({
                            width: 100 / l.options.slidesPerRow + "%",
                            display: "inline-block",
                        });
            }
        }),
        (e.prototype.checkResponsive = function (e, t) {
            var o,
                s,
                n,
                r = this,
                l = !1,
                d = r.$slider.width(),
                a = window.innerWidth || i(window).width();
            if (
                ("window" === r.respondTo
                    ? (n = a)
                    : "slider" === r.respondTo
                    ? (n = d)
                    : "min" === r.respondTo && (n = Math.min(a, d)),
                r.options.responsive &&
                    r.options.responsive.length &&
                    null !== r.options.responsive)
            ) {
                s = null;
                for (o in r.breakpoints)
                    r.breakpoints.hasOwnProperty(o) &&
                        (!1 === r.originalSettings.mobileFirst
                            ? n < r.breakpoints[o] && (s = r.breakpoints[o])
                            : n > r.breakpoints[o] && (s = r.breakpoints[o]));
                null !== s
                    ? null !== r.activeBreakpoint
                        ? (s !== r.activeBreakpoint || t) &&
                          ((r.activeBreakpoint = s),
                          "unslick" === r.breakpointSettings[s]
                              ? r.unslick(s)
                              : ((r.options = i.extend(
                                    {},
                                    r.originalSettings,
                                    r.breakpointSettings[s]
                                )),
                                !0 === e &&
                                    (r.currentSlide = r.options.initialSlide),
                                r.refresh(e)),
                          (l = s))
                        : ((r.activeBreakpoint = s),
                          "unslick" === r.breakpointSettings[s]
                              ? r.unslick(s)
                              : ((r.options = i.extend(
                                    {},
                                    r.originalSettings,
                                    r.breakpointSettings[s]
                                )),
                                !0 === e &&
                                    (r.currentSlide = r.options.initialSlide),
                                r.refresh(e)),
                          (l = s))
                    : null !== r.activeBreakpoint &&
                      ((r.activeBreakpoint = null),
                      (r.options = r.originalSettings),
                      !0 === e && (r.currentSlide = r.options.initialSlide),
                      r.refresh(e),
                      (l = s)),
                    e || !1 === l || r.$slider.trigger("breakpoint", [r, l]);
            }
        }),
        (e.prototype.changeSlide = function (e, t) {
            var o,
                s,
                n,
                r = this,
                l = i(e.currentTarget);
            switch (
                (l.is("a") && e.preventDefault(),
                l.is("li") || (l = l.closest("li")),
                (n = r.slideCount % r.options.slidesToScroll != 0),
                (o = n
                    ? 0
                    : (r.slideCount - r.currentSlide) %
                      r.options.slidesToScroll),
                e.data.message)
            ) {
                case "previous":
                    (s =
                        0 === o
                            ? r.options.slidesToScroll
                            : r.options.slidesToShow - o),
                        r.slideCount > r.options.slidesToShow &&
                            r.slideHandler(r.currentSlide - s, !1, t);
                    break;
                case "next":
                    (s = 0 === o ? r.options.slidesToScroll : o),
                        r.slideCount > r.options.slidesToShow &&
                            r.slideHandler(r.currentSlide + s, !1, t);
                    break;
                case "index":
                    var d =
                        0 === e.data.index
                            ? 0
                            : e.data.index ||
                              l.index() * r.options.slidesToScroll;
                    r.slideHandler(r.checkNavigable(d), !1, t),
                        l.children().trigger("focus");
                    break;
                default:
                    return;
            }
        }),
        (e.prototype.checkNavigable = function (i) {
            var e, t;
            if (
                ((e = this.getNavigableIndexes()), (t = 0), i > e[e.length - 1])
            )
                i = e[e.length - 1];
            else
                for (var o in e) {
                    if (i < e[o]) {
                        i = t;
                        break;
                    }
                    t = e[o];
                }
            return i;
        }),
        (e.prototype.cleanUpEvents = function () {
            var e = this;
            e.options.dots &&
                null !== e.$dots &&
                (i("li", e.$dots)
                    .off("click.slick", e.changeSlide)
                    .off("mouseenter.slick", i.proxy(e.interrupt, e, !0))
                    .off("mouseleave.slick", i.proxy(e.interrupt, e, !1)),
                !0 === e.options.accessibility &&
                    e.$dots.off("keydown.slick", e.keyHandler)),
                e.$slider.off("focus.slick blur.slick"),
                !0 === e.options.arrows &&
                    e.slideCount > e.options.slidesToShow &&
                    (e.$prevArrow &&
                        e.$prevArrow.off("click.slick", e.changeSlide),
                    e.$nextArrow &&
                        e.$nextArrow.off("click.slick", e.changeSlide),
                    !0 === e.options.accessibility &&
                        (e.$prevArrow &&
                            e.$prevArrow.off("keydown.slick", e.keyHandler),
                        e.$nextArrow &&
                            e.$nextArrow.off("keydown.slick", e.keyHandler))),
                e.$list.off("touchstart.slick mousedown.slick", e.swipeHandler),
                e.$list.off("touchmove.slick mousemove.slick", e.swipeHandler),
                e.$list.off("touchend.slick mouseup.slick", e.swipeHandler),
                e.$list.off(
                    "touchcancel.slick mouseleave.slick",
                    e.swipeHandler
                ),
                e.$list.off("click.slick", e.clickHandler),
                i(document).off(e.visibilityChange, e.visibility),
                e.cleanUpSlideEvents(),
                !0 === e.options.accessibility &&
                    e.$list.off("keydown.slick", e.keyHandler),
                !0 === e.options.focusOnSelect &&
                    i(e.$slideTrack)
                        .children()
                        .off("click.slick", e.selectHandler),
                i(window).off(
                    "orientationchange.slick.slick-" + e.instanceUid,
                    e.orientationChange
                ),
                i(window).off("resize.slick.slick-" + e.instanceUid, e.resize),
                i("[draggable!=true]", e.$slideTrack).off(
                    "dragstart",
                    e.preventDefault
                ),
                i(window).off(
                    "load.slick.slick-" + e.instanceUid,
                    e.setPosition
                );
        }),
        (e.prototype.cleanUpSlideEvents = function () {
            var e = this;
            e.$list.off("mouseenter.slick", i.proxy(e.interrupt, e, !0)),
                e.$list.off("mouseleave.slick", i.proxy(e.interrupt, e, !1));
        }),
        (e.prototype.cleanUpRows = function () {
            var i,
                e = this;
            e.options.rows > 1 &&
                ((i = e.$slides.children().children()).removeAttr("style"),
                e.$slider.empty().append(i));
        }),
        (e.prototype.clickHandler = function (i) {
            !1 === this.shouldClick &&
                (i.stopImmediatePropagation(),
                i.stopPropagation(),
                i.preventDefault());
        }),
        (e.prototype.destroy = function (e) {
            var t = this;
            t.autoPlayClear(),
                (t.touchObject = {}),
                t.cleanUpEvents(),
                i(".slick-cloned", t.$slider).detach(),
                t.$dots && t.$dots.remove(),
                t.$prevArrow &&
                    t.$prevArrow.length &&
                    (t.$prevArrow
                        .removeClass("slick-disabled slick-arrow slick-hidden")
                        .removeAttr("aria-hidden aria-disabled tabindex")
                        .css("display", ""),
                    t.htmlExpr.test(t.options.prevArrow) &&
                        t.$prevArrow.remove()),
                t.$nextArrow &&
                    t.$nextArrow.length &&
                    (t.$nextArrow
                        .removeClass("slick-disabled slick-arrow slick-hidden")
                        .removeAttr("aria-hidden aria-disabled tabindex")
                        .css("display", ""),
                    t.htmlExpr.test(t.options.nextArrow) &&
                        t.$nextArrow.remove()),
                t.$slides &&
                    (t.$slides
                        .removeClass(
                            "slick-slide slick-active slick-center slick-visible slick-current"
                        )
                        .removeAttr("aria-hidden")
                        .removeAttr("data-slick-index")
                        .each(function () {
                            i(this).attr(
                                "style",
                                i(this).data("originalStyling")
                            );
                        }),
                    t.$slideTrack.children(this.options.slide).detach(),
                    t.$slideTrack.detach(),
                    t.$list.detach(),
                    t.$slider.append(t.$slides)),
                t.cleanUpRows(),
                t.$slider.removeClass("slick-slider"),
                t.$slider.removeClass("slick-initialized"),
                t.$slider.removeClass("slick-dotted"),
                (t.unslicked = !0),
                e || t.$slider.trigger("destroy", [t]);
        }),
        (e.prototype.disableTransition = function (i) {
            var e = this,
                t = {};
            (t[e.transitionType] = ""),
                !1 === e.options.fade
                    ? e.$slideTrack.css(t)
                    : e.$slides.eq(i).css(t);
        }),
        (e.prototype.fadeSlide = function (i, e) {
            var t = this;
            !1 === t.cssTransitions
                ? (t.$slides.eq(i).css({ zIndex: t.options.zIndex }),
                  t.$slides
                      .eq(i)
                      .animate(
                          { opacity: 1 },
                          t.options.speed,
                          t.options.easing,
                          e
                      ))
                : (t.applyTransition(i),
                  t.$slides.eq(i).css({ opacity: 1, zIndex: t.options.zIndex }),
                  e &&
                      setTimeout(function () {
                          t.disableTransition(i), e.call();
                      }, t.options.speed));
        }),
        (e.prototype.fadeSlideOut = function (i) {
            var e = this;
            !1 === e.cssTransitions
                ? e.$slides
                      .eq(i)
                      .animate(
                          { opacity: 0, zIndex: e.options.zIndex - 2 },
                          e.options.speed,
                          e.options.easing
                      )
                : (e.applyTransition(i),
                  e.$slides
                      .eq(i)
                      .css({ opacity: 0, zIndex: e.options.zIndex - 2 }));
        }),
        (e.prototype.filterSlides = e.prototype.slickFilter =
            function (i) {
                var e = this;
                null !== i &&
                    ((e.$slidesCache = e.$slides),
                    e.unload(),
                    e.$slideTrack.children(this.options.slide).detach(),
                    e.$slidesCache.filter(i).appendTo(e.$slideTrack),
                    e.reinit());
            }),
        (e.prototype.focusHandler = function () {
            var e = this;
            e.$slider
                .off("focus.slick blur.slick")
                .on("focus.slick blur.slick", "*", function (t) {
                    t.stopImmediatePropagation();
                    var o = i(this);
                    setTimeout(function () {
                        e.options.pauseOnFocus &&
                            ((e.focussed = o.is(":focus")), e.autoPlay());
                    }, 0);
                });
        }),
        (e.prototype.getCurrent = e.prototype.slickCurrentSlide =
            function () {
                return this.currentSlide;
            }),
        (e.prototype.getDotCount = function () {
            var i = this,
                e = 0,
                t = 0,
                o = 0;
            if (!0 === i.options.infinite)
                if (i.slideCount <= i.options.slidesToShow) ++o;
                else
                    for (; e < i.slideCount; )
                        ++o,
                            (e = t + i.options.slidesToScroll),
                            (t +=
                                i.options.slidesToScroll <=
                                i.options.slidesToShow
                                    ? i.options.slidesToScroll
                                    : i.options.slidesToShow);
            else if (!0 === i.options.centerMode) o = i.slideCount;
            else if (i.options.asNavFor)
                for (; e < i.slideCount; )
                    ++o,
                        (e = t + i.options.slidesToScroll),
                        (t +=
                            i.options.slidesToScroll <= i.options.slidesToShow
                                ? i.options.slidesToScroll
                                : i.options.slidesToShow);
            else
                o =
                    1 +
                    Math.ceil(
                        (i.slideCount - i.options.slidesToShow) /
                            i.options.slidesToScroll
                    );
            return o - 1;
        }),
        (e.prototype.getLeft = function (i) {
            var e,
                t,
                o,
                s,
                n = this,
                r = 0;
            return (
                (n.slideOffset = 0),
                (t = n.$slides.first().outerHeight(!0)),
                !0 === n.options.infinite
                    ? (n.slideCount > n.options.slidesToShow &&
                          ((n.slideOffset =
                              n.slideWidth * n.options.slidesToShow * -1),
                          (s = -1),
                          !0 === n.options.vertical &&
                              !0 === n.options.centerMode &&
                              (2 === n.options.slidesToShow
                                  ? (s = -1.5)
                                  : 1 === n.options.slidesToShow && (s = -2)),
                          (r = t * n.options.slidesToShow * s)),
                      n.slideCount % n.options.slidesToScroll != 0 &&
                          i + n.options.slidesToScroll > n.slideCount &&
                          n.slideCount > n.options.slidesToShow &&
                          (i > n.slideCount
                              ? ((n.slideOffset =
                                    (n.options.slidesToShow -
                                        (i - n.slideCount)) *
                                    n.slideWidth *
                                    -1),
                                (r =
                                    (n.options.slidesToShow -
                                        (i - n.slideCount)) *
                                    t *
                                    -1))
                              : ((n.slideOffset =
                                    (n.slideCount % n.options.slidesToScroll) *
                                    n.slideWidth *
                                    -1),
                                (r =
                                    (n.slideCount % n.options.slidesToScroll) *
                                    t *
                                    -1))))
                    : i + n.options.slidesToShow > n.slideCount &&
                      ((n.slideOffset =
                          (i + n.options.slidesToShow - n.slideCount) *
                          n.slideWidth),
                      (r = (i + n.options.slidesToShow - n.slideCount) * t)),
                n.slideCount <= n.options.slidesToShow &&
                    ((n.slideOffset = 0), (r = 0)),
                !0 === n.options.centerMode &&
                n.slideCount <= n.options.slidesToShow
                    ? (n.slideOffset =
                          (n.slideWidth * Math.floor(n.options.slidesToShow)) /
                              2 -
                          (n.slideWidth * n.slideCount) / 2)
                    : !0 === n.options.centerMode && !0 === n.options.infinite
                    ? (n.slideOffset +=
                          n.slideWidth *
                              Math.floor(n.options.slidesToShow / 2) -
                          n.slideWidth)
                    : !0 === n.options.centerMode &&
                      ((n.slideOffset = 0),
                      (n.slideOffset +=
                          n.slideWidth *
                          Math.floor(n.options.slidesToShow / 2))),
                (e =
                    !1 === n.options.vertical
                        ? i * n.slideWidth * -1 + n.slideOffset
                        : i * t * -1 + r),
                !0 === n.options.variableWidth &&
                    ((o =
                        n.slideCount <= n.options.slidesToShow ||
                        !1 === n.options.infinite
                            ? n.$slideTrack.children(".slick-slide").eq(i)
                            : n.$slideTrack
                                  .children(".slick-slide")
                                  .eq(i + n.options.slidesToShow)),
                    (e =
                        !0 === n.options.rtl
                            ? o[0]
                                ? -1 *
                                  (n.$slideTrack.width() -
                                      o[0].offsetLeft -
                                      o.width())
                                : 0
                            : o[0]
                            ? -1 * o[0].offsetLeft
                            : 0),
                    !0 === n.options.centerMode &&
                        ((o =
                            n.slideCount <= n.options.slidesToShow ||
                            !1 === n.options.infinite
                                ? n.$slideTrack.children(".slick-slide").eq(i)
                                : n.$slideTrack
                                      .children(".slick-slide")
                                      .eq(i + n.options.slidesToShow + 1)),
                        (e =
                            !0 === n.options.rtl
                                ? o[0]
                                    ? -1 *
                                      (n.$slideTrack.width() -
                                          o[0].offsetLeft -
                                          o.width())
                                    : 0
                                : o[0]
                                ? -1 * o[0].offsetLeft
                                : 0),
                        (e += (n.$list.width() - o.outerWidth()) / 2))),
                e
            );
        }),
        (e.prototype.getOption = e.prototype.slickGetOption =
            function (i) {
                return this.options[i];
            }),
        (e.prototype.getNavigableIndexes = function () {
            var i,
                e = this,
                t = 0,
                o = 0,
                s = [];
            for (
                !1 === e.options.infinite
                    ? (i = e.slideCount)
                    : ((t = -1 * e.options.slidesToScroll),
                      (o = -1 * e.options.slidesToScroll),
                      (i = 2 * e.slideCount));
                t < i;

            )
                s.push(t),
                    (t = o + e.options.slidesToScroll),
                    (o +=
                        e.options.slidesToScroll <= e.options.slidesToShow
                            ? e.options.slidesToScroll
                            : e.options.slidesToShow);
            return s;
        }),
        (e.prototype.getSlick = function () {
            return this;
        }),
        (e.prototype.getSlideCount = function () {
            var e,
                t,
                o = this;
            return (
                (t =
                    !0 === o.options.centerMode
                        ? o.slideWidth * Math.floor(o.options.slidesToShow / 2)
                        : 0),
                !0 === o.options.swipeToSlide
                    ? (o.$slideTrack.find(".slick-slide").each(function (s, n) {
                          if (
                              n.offsetLeft - t + i(n).outerWidth() / 2 >
                              -1 * o.swipeLeft
                          )
                              return (e = n), !1;
                      }),
                      Math.abs(
                          i(e).attr("data-slick-index") - o.currentSlide
                      ) || 1)
                    : o.options.slidesToScroll
            );
        }),
        (e.prototype.goTo = e.prototype.slickGoTo =
            function (i, e) {
                this.changeSlide(
                    { data: { message: "index", index: parseInt(i) } },
                    e
                );
            }),
        (e.prototype.init = function (e) {
            var t = this;
            i(t.$slider).hasClass("slick-initialized") ||
                (i(t.$slider).addClass("slick-initialized"),
                t.buildRows(),
                t.buildOut(),
                t.setProps(),
                t.startLoad(),
                t.loadSlider(),
                t.initializeEvents(),
                t.updateArrows(),
                t.updateDots(),
                t.checkResponsive(!0),
                t.focusHandler()),
                e && t.$slider.trigger("init", [t]),
                !0 === t.options.accessibility && t.initADA(),
                t.options.autoplay && ((t.paused = !1), t.autoPlay());
        }),
        (e.prototype.initADA = function () {
            var e = this,
                t = Math.ceil(e.slideCount / e.options.slidesToShow),
                o = e.getNavigableIndexes().filter(function (i) {
                    return i >= 0 && i < e.slideCount;
                });
            e.$slides
                .add(e.$slideTrack.find(".slick-cloned"))
                .attr({ "aria-hidden": "true", tabindex: "-1" })
                .find("a, input, button, select")
                .attr({ tabindex: "-1" }),
                null !== e.$dots &&
                    (e.$slides
                        .not(e.$slideTrack.find(".slick-cloned"))
                        .each(function (t) {
                            var s = o.indexOf(t);
                            i(this).attr({
                                role: "tabpanel",
                                id: "slick-slide" + e.instanceUid + t,
                                tabindex: -1,
                            }),
                                -1 !== s &&
                                    i(this).attr({
                                        "aria-describedby":
                                            "slick-slide-control" +
                                            e.instanceUid +
                                            s,
                                    });
                        }),
                    e.$dots
                        .attr("role", "tablist")
                        .find("li")
                        .each(function (s) {
                            var n = o[s];
                            i(this).attr({ role: "presentation" }),
                                i(this)
                                    .find("button")
                                    .first()
                                    .attr({
                                        role: "tab",
                                        id:
                                            "slick-slide-control" +
                                            e.instanceUid +
                                            s,
                                        "aria-controls":
                                            "slick-slide" + e.instanceUid + n,
                                        "aria-label": s + 1 + " of " + t,
                                        "aria-selected": null,
                                        tabindex: "-1",
                                    });
                        })
                        .eq(e.currentSlide)
                        .find("button")
                        .attr({ "aria-selected": "true", tabindex: "0" })
                        .end());
            for (
                var s = e.currentSlide, n = s + e.options.slidesToShow;
                s < n;
                s++
            )
                e.$slides.eq(s).attr("tabindex", 0);
            e.activateADA();
        }),
        (e.prototype.initArrowEvents = function () {
            var i = this;
            !0 === i.options.arrows &&
                i.slideCount > i.options.slidesToShow &&
                (i.$prevArrow
                    .off("click.slick")
                    .on("click.slick", { message: "previous" }, i.changeSlide),
                i.$nextArrow
                    .off("click.slick")
                    .on("click.slick", { message: "next" }, i.changeSlide),
                !0 === i.options.accessibility &&
                    (i.$prevArrow.on("keydown.slick", i.keyHandler),
                    i.$nextArrow.on("keydown.slick", i.keyHandler)));
        }),
        (e.prototype.initDotEvents = function () {
            var e = this;
            !0 === e.options.dots &&
                (i("li", e.$dots).on(
                    "click.slick",
                    { message: "index" },
                    e.changeSlide
                ),
                !0 === e.options.accessibility &&
                    e.$dots.on("keydown.slick", e.keyHandler)),
                !0 === e.options.dots &&
                    !0 === e.options.pauseOnDotsHover &&
                    i("li", e.$dots)
                        .on("mouseenter.slick", i.proxy(e.interrupt, e, !0))
                        .on("mouseleave.slick", i.proxy(e.interrupt, e, !1));
        }),
        (e.prototype.initSlideEvents = function () {
            var e = this;
            e.options.pauseOnHover &&
                (e.$list.on("mouseenter.slick", i.proxy(e.interrupt, e, !0)),
                e.$list.on("mouseleave.slick", i.proxy(e.interrupt, e, !1)));
        }),
        (e.prototype.initializeEvents = function () {
            var e = this;
            e.initArrowEvents(),
                e.initDotEvents(),
                e.initSlideEvents(),
                e.$list.on(
                    "touchstart.slick mousedown.slick",
                    { action: "start" },
                    e.swipeHandler
                ),
                e.$list.on(
                    "touchmove.slick mousemove.slick",
                    { action: "move" },
                    e.swipeHandler
                ),
                e.$list.on(
                    "touchend.slick mouseup.slick",
                    { action: "end" },
                    e.swipeHandler
                ),
                e.$list.on(
                    "touchcancel.slick mouseleave.slick",
                    { action: "end" },
                    e.swipeHandler
                ),
                e.$list.on("click.slick", e.clickHandler),
                i(document).on(e.visibilityChange, i.proxy(e.visibility, e)),
                !0 === e.options.accessibility &&
                    e.$list.on("keydown.slick", e.keyHandler),
                !0 === e.options.focusOnSelect &&
                    i(e.$slideTrack)
                        .children()
                        .on("click.slick", e.selectHandler),
                i(window).on(
                    "orientationchange.slick.slick-" + e.instanceUid,
                    i.proxy(e.orientationChange, e)
                ),
                i(window).on(
                    "resize.slick.slick-" + e.instanceUid,
                    i.proxy(e.resize, e)
                ),
                i("[draggable!=true]", e.$slideTrack).on(
                    "dragstart",
                    e.preventDefault
                ),
                i(window).on(
                    "load.slick.slick-" + e.instanceUid,
                    e.setPosition
                ),
                i(e.setPosition);
        }),
        (e.prototype.initUI = function () {
            var i = this;
            !0 === i.options.arrows &&
                i.slideCount > i.options.slidesToShow &&
                (i.$prevArrow.show(), i.$nextArrow.show()),
                !0 === i.options.dots &&
                    i.slideCount > i.options.slidesToShow &&
                    i.$dots.show();
        }),
        (e.prototype.keyHandler = function (i) {
            var e = this;
            i.target.tagName.match("TEXTAREA|INPUT|SELECT") ||
                (37 === i.keyCode && !0 === e.options.accessibility
                    ? e.changeSlide({
                          data: {
                              message:
                                  !0 === e.options.rtl ? "next" : "previous",
                          },
                      })
                    : 39 === i.keyCode &&
                      !0 === e.options.accessibility &&
                      e.changeSlide({
                          data: {
                              message:
                                  !0 === e.options.rtl ? "previous" : "next",
                          },
                      }));
        }),
        (e.prototype.lazyLoad = function () {
            function e(e) {
                i("img[data-lazy]", e).each(function () {
                    var e = i(this),
                        t = i(this).attr("data-lazy"),
                        o = i(this).attr("data-srcset"),
                        s =
                            i(this).attr("data-sizes") ||
                            n.$slider.attr("data-sizes"),
                        r = document.createElement("img");
                    (r.onload = function () {
                        e.animate({ opacity: 0 }, 100, function () {
                            o && (e.attr("srcset", o), s && e.attr("sizes", s)),
                                e
                                    .attr("src", t)
                                    .animate({ opacity: 1 }, 200, function () {
                                        e.removeAttr(
                                            "data-lazy data-srcset data-sizes"
                                        ).removeClass("slick-loading");
                                    }),
                                n.$slider.trigger("lazyLoaded", [n, e, t]);
                        });
                    }),
                        (r.onerror = function () {
                            e
                                .removeAttr("data-lazy")
                                .removeClass("slick-loading")
                                .addClass("slick-lazyload-error"),
                                n.$slider.trigger("lazyLoadError", [n, e, t]);
                        }),
                        (r.src = t);
                });
            }
            var t,
                o,
                s,
                n = this;
            if (
                (!0 === n.options.centerMode
                    ? !0 === n.options.infinite
                        ? (s =
                              (o =
                                  n.currentSlide +
                                  (n.options.slidesToShow / 2 + 1)) +
                              n.options.slidesToShow +
                              2)
                        : ((o = Math.max(
                              0,
                              n.currentSlide - (n.options.slidesToShow / 2 + 1)
                          )),
                          (s =
                              n.options.slidesToShow / 2 +
                              1 +
                              2 +
                              n.currentSlide))
                    : ((o = n.options.infinite
                          ? n.options.slidesToShow + n.currentSlide
                          : n.currentSlide),
                      (s = Math.ceil(o + n.options.slidesToShow)),
                      !0 === n.options.fade &&
                          (o > 0 && o--, s <= n.slideCount && s++)),
                (t = n.$slider.find(".slick-slide").slice(o, s)),
                "anticipated" === n.options.lazyLoad)
            )
                for (
                    var r = o - 1,
                        l = s,
                        d = n.$slider.find(".slick-slide"),
                        a = 0;
                    a < n.options.slidesToScroll;
                    a++
                )
                    r < 0 && (r = n.slideCount - 1),
                        (t = (t = t.add(d.eq(r))).add(d.eq(l))),
                        r--,
                        l++;
            e(t),
                n.slideCount <= n.options.slidesToShow
                    ? e(n.$slider.find(".slick-slide"))
                    : n.currentSlide >= n.slideCount - n.options.slidesToShow
                    ? e(
                          n.$slider
                              .find(".slick-cloned")
                              .slice(0, n.options.slidesToShow)
                      )
                    : 0 === n.currentSlide &&
                      e(
                          n.$slider
                              .find(".slick-cloned")
                              .slice(-1 * n.options.slidesToShow)
                      );
        }),
        (e.prototype.loadSlider = function () {
            var i = this;
            i.setPosition(),
                i.$slideTrack.css({ opacity: 1 }),
                i.$slider.removeClass("slick-loading"),
                i.initUI(),
                "progressive" === i.options.lazyLoad && i.progressiveLazyLoad();
        }),
        (e.prototype.next = e.prototype.slickNext =
            function () {
                this.changeSlide({ data: { message: "next" } });
            }),
        (e.prototype.orientationChange = function () {
            var i = this;
            i.checkResponsive(), i.setPosition();
        }),
        (e.prototype.pause = e.prototype.slickPause =
            function () {
                var i = this;
                i.autoPlayClear(), (i.paused = !0);
            }),
        (e.prototype.play = e.prototype.slickPlay =
            function () {
                var i = this;
                i.autoPlay(),
                    (i.options.autoplay = !0),
                    (i.paused = !1),
                    (i.focussed = !1),
                    (i.interrupted = !1);
            }),
        (e.prototype.postSlide = function (e) {
            var t = this;
            t.unslicked ||
                (t.$slider.trigger("afterChange", [t, e]),
                (t.animating = !1),
                t.slideCount > t.options.slidesToShow && t.setPosition(),
                (t.swipeLeft = null),
                t.options.autoplay && t.autoPlay(),
                !0 === t.options.accessibility &&
                    (t.initADA(),
                    t.options.focusOnChange &&
                        i(t.$slides.get(t.currentSlide))
                            .attr("tabindex", 0)
                            .focus()));
        }),
        (e.prototype.prev = e.prototype.slickPrev =
            function () {
                this.changeSlide({ data: { message: "previous" } });
            }),
        (e.prototype.preventDefault = function (i) {
            i.preventDefault();
        }),
        (e.prototype.progressiveLazyLoad = function (e) {
            e = e || 1;
            var t,
                o,
                s,
                n,
                r,
                l = this,
                d = i("img[data-lazy]", l.$slider);
            d.length
                ? ((t = d.first()),
                  (o = t.attr("data-lazy")),
                  (s = t.attr("data-srcset")),
                  (n = t.attr("data-sizes") || l.$slider.attr("data-sizes")),
                  ((r = document.createElement("img")).onload = function () {
                      s && (t.attr("srcset", s), n && t.attr("sizes", n)),
                          t
                              .attr("src", o)
                              .removeAttr("data-lazy data-srcset data-sizes")
                              .removeClass("slick-loading"),
                          !0 === l.options.adaptiveHeight && l.setPosition(),
                          l.$slider.trigger("lazyLoaded", [l, t, o]),
                          l.progressiveLazyLoad();
                  }),
                  (r.onerror = function () {
                      e < 3
                          ? setTimeout(function () {
                                l.progressiveLazyLoad(e + 1);
                            }, 500)
                          : (t
                                .removeAttr("data-lazy")
                                .removeClass("slick-loading")
                                .addClass("slick-lazyload-error"),
                            l.$slider.trigger("lazyLoadError", [l, t, o]),
                            l.progressiveLazyLoad());
                  }),
                  (r.src = o))
                : l.$slider.trigger("allImagesLoaded", [l]);
        }),
        (e.prototype.refresh = function (e) {
            var t,
                o,
                s = this;
            (o = s.slideCount - s.options.slidesToShow),
                !s.options.infinite &&
                    s.currentSlide > o &&
                    (s.currentSlide = o),
                s.slideCount <= s.options.slidesToShow && (s.currentSlide = 0),
                (t = s.currentSlide),
                s.destroy(!0),
                i.extend(s, s.initials, { currentSlide: t }),
                s.init(),
                e ||
                    s.changeSlide({ data: { message: "index", index: t } }, !1);
        }),
        (e.prototype.registerBreakpoints = function () {
            var e,
                t,
                o,
                s = this,
                n = s.options.responsive || null;
            if ("array" === i.type(n) && n.length) {
                s.respondTo = s.options.respondTo || "window";
                for (e in n)
                    if (((o = s.breakpoints.length - 1), n.hasOwnProperty(e))) {
                        for (t = n[e].breakpoint; o >= 0; )
                            s.breakpoints[o] &&
                                s.breakpoints[o] === t &&
                                s.breakpoints.splice(o, 1),
                                o--;
                        s.breakpoints.push(t),
                            (s.breakpointSettings[t] = n[e].settings);
                    }
                s.breakpoints.sort(function (i, e) {
                    return s.options.mobileFirst ? i - e : e - i;
                });
            }
        }),
        (e.prototype.reinit = function () {
            var e = this;
            (e.$slides = e.$slideTrack
                .children(e.options.slide)
                .addClass("slick-slide")),
                (e.slideCount = e.$slides.length),
                e.currentSlide >= e.slideCount &&
                    0 !== e.currentSlide &&
                    (e.currentSlide =
                        e.currentSlide - e.options.slidesToScroll),
                e.slideCount <= e.options.slidesToShow && (e.currentSlide = 0),
                e.registerBreakpoints(),
                e.setProps(),
                e.setupInfinite(),
                e.buildArrows(),
                e.updateArrows(),
                e.initArrowEvents(),
                e.buildDots(),
                e.updateDots(),
                e.initDotEvents(),
                e.cleanUpSlideEvents(),
                e.initSlideEvents(),
                e.checkResponsive(!1, !0),
                !0 === e.options.focusOnSelect &&
                    i(e.$slideTrack)
                        .children()
                        .on("click.slick", e.selectHandler),
                e.setSlideClasses(
                    "number" == typeof e.currentSlide ? e.currentSlide : 0
                ),
                e.setPosition(),
                e.focusHandler(),
                (e.paused = !e.options.autoplay),
                e.autoPlay(),
                e.$slider.trigger("reInit", [e]);
        }),
        (e.prototype.resize = function () {
            var e = this;
            i(window).width() !== e.windowWidth &&
                (clearTimeout(e.windowDelay),
                (e.windowDelay = window.setTimeout(function () {
                    (e.windowWidth = i(window).width()),
                        e.checkResponsive(),
                        e.unslicked || e.setPosition();
                }, 50)));
        }),
        (e.prototype.removeSlide = e.prototype.slickRemove =
            function (i, e, t) {
                var o = this;
                if (
                    ((i =
                        "boolean" == typeof i
                            ? !0 === (e = i)
                                ? 0
                                : o.slideCount - 1
                            : !0 === e
                            ? --i
                            : i),
                    o.slideCount < 1 || i < 0 || i > o.slideCount - 1)
                )
                    return !1;
                o.unload(),
                    !0 === t
                        ? o.$slideTrack.children().remove()
                        : o.$slideTrack
                              .children(this.options.slide)
                              .eq(i)
                              .remove(),
                    (o.$slides = o.$slideTrack.children(this.options.slide)),
                    o.$slideTrack.children(this.options.slide).detach(),
                    o.$slideTrack.append(o.$slides),
                    (o.$slidesCache = o.$slides),
                    o.reinit();
            }),
        (e.prototype.setCSS = function (i) {
            var e,
                t,
                o = this,
                s = {};
            !0 === o.options.rtl && (i = -i),
                (e = "left" == o.positionProp ? Math.ceil(i) + "px" : "0px"),
                (t = "top" == o.positionProp ? Math.ceil(i) + "px" : "0px"),
                (s[o.positionProp] = i),
                !1 === o.transformsEnabled
                    ? o.$slideTrack.css(s)
                    : ((s = {}),
                      !1 === o.cssTransitions
                          ? ((s[o.animType] =
                                "translate(" + e + ", " + t + ")"),
                            o.$slideTrack.css(s))
                          : ((s[o.animType] =
                                "translate3d(" + e + ", " + t + ", 0px)"),
                            o.$slideTrack.css(s)));
        }),
        (e.prototype.setDimensions = function () {
            var i = this;
            !1 === i.options.vertical
                ? !0 === i.options.centerMode &&
                  i.$list.css({ padding: "0px " + i.options.centerPadding })
                : (i.$list.height(
                      i.$slides.first().outerHeight(!0) * i.options.slidesToShow
                  ),
                  !0 === i.options.centerMode &&
                      i.$list.css({
                          padding: i.options.centerPadding + " 0px",
                      })),
                (i.listWidth = i.$list.width()),
                (i.listHeight = i.$list.height()),
                !1 === i.options.vertical && !1 === i.options.variableWidth
                    ? ((i.slideWidth = Math.ceil(
                          i.listWidth / i.options.slidesToShow
                      )),
                      i.$slideTrack.width(
                          Math.ceil(
                              i.slideWidth *
                                  i.$slideTrack.children(".slick-slide").length
                          )
                      ))
                    : !0 === i.options.variableWidth
                    ? i.$slideTrack.width(5e3 * i.slideCount)
                    : ((i.slideWidth = Math.ceil(i.listWidth)),
                      i.$slideTrack.height(
                          Math.ceil(
                              i.$slides.first().outerHeight(!0) *
                                  i.$slideTrack.children(".slick-slide").length
                          )
                      ));
            var e =
                i.$slides.first().outerWidth(!0) - i.$slides.first().width();
            !1 === i.options.variableWidth &&
                i.$slideTrack.children(".slick-slide").width(i.slideWidth - e);
        }),
        (e.prototype.setFade = function () {
            var e,
                t = this;
            t.$slides.each(function (o, s) {
                (e = t.slideWidth * o * -1),
                    !0 === t.options.rtl
                        ? i(s).css({
                              position: "relative",
                              right: e,
                              top: 0,
                              zIndex: t.options.zIndex - 2,
                              opacity: 0,
                          })
                        : i(s).css({
                              position: "relative",
                              left: e,
                              top: 0,
                              zIndex: t.options.zIndex - 2,
                              opacity: 0,
                          });
            }),
                t.$slides
                    .eq(t.currentSlide)
                    .css({ zIndex: t.options.zIndex - 1, opacity: 1 });
        }),
        (e.prototype.setHeight = function () {
            var i = this;
            if (
                1 === i.options.slidesToShow &&
                !0 === i.options.adaptiveHeight &&
                !1 === i.options.vertical
            ) {
                var e = i.$slides.eq(i.currentSlide).outerHeight(!0);
                i.$list.css("height", e);
            }
        }),
        (e.prototype.setOption = e.prototype.slickSetOption =
            function () {
                var e,
                    t,
                    o,
                    s,
                    n,
                    r = this,
                    l = !1;
                if (
                    ("object" === i.type(arguments[0])
                        ? ((o = arguments[0]),
                          (l = arguments[1]),
                          (n = "multiple"))
                        : "string" === i.type(arguments[0]) &&
                          ((o = arguments[0]),
                          (s = arguments[1]),
                          (l = arguments[2]),
                          "responsive" === arguments[0] &&
                          "array" === i.type(arguments[1])
                              ? (n = "responsive")
                              : void 0 !== arguments[1] && (n = "single")),
                    "single" === n)
                )
                    r.options[o] = s;
                else if ("multiple" === n)
                    i.each(o, function (i, e) {
                        r.options[i] = e;
                    });
                else if ("responsive" === n)
                    for (t in s)
                        if ("array" !== i.type(r.options.responsive))
                            r.options.responsive = [s[t]];
                        else {
                            for (e = r.options.responsive.length - 1; e >= 0; )
                                r.options.responsive[e].breakpoint ===
                                    s[t].breakpoint &&
                                    r.options.responsive.splice(e, 1),
                                    e--;
                            r.options.responsive.push(s[t]);
                        }
                l && (r.unload(), r.reinit());
            }),
        (e.prototype.setPosition = function () {
            var i = this;
            i.setDimensions(),
                i.setHeight(),
                !1 === i.options.fade
                    ? i.setCSS(i.getLeft(i.currentSlide))
                    : i.setFade(),
                i.$slider.trigger("setPosition", [i]);
        }),
        (e.prototype.setProps = function () {
            var i = this,
                e = document.body.style;
            (i.positionProp = !0 === i.options.vertical ? "top" : "left"),
                "top" === i.positionProp
                    ? i.$slider.addClass("slick-vertical")
                    : i.$slider.removeClass("slick-vertical"),
                (void 0 === e.WebkitTransition &&
                    void 0 === e.MozTransition &&
                    void 0 === e.msTransition) ||
                    (!0 === i.options.useCSS && (i.cssTransitions = !0)),
                i.options.fade &&
                    ("number" == typeof i.options.zIndex
                        ? i.options.zIndex < 3 && (i.options.zIndex = 3)
                        : (i.options.zIndex = i.defaults.zIndex)),
                void 0 !== e.OTransform &&
                    ((i.animType = "OTransform"),
                    (i.transformType = "-o-transform"),
                    (i.transitionType = "OTransition"),
                    void 0 === e.perspectiveProperty &&
                        void 0 === e.webkitPerspective &&
                        (i.animType = !1)),
                void 0 !== e.MozTransform &&
                    ((i.animType = "MozTransform"),
                    (i.transformType = "-moz-transform"),
                    (i.transitionType = "MozTransition"),
                    void 0 === e.perspectiveProperty &&
                        void 0 === e.MozPerspective &&
                        (i.animType = !1)),
                void 0 !== e.webkitTransform &&
                    ((i.animType = "webkitTransform"),
                    (i.transformType = "-webkit-transform"),
                    (i.transitionType = "webkitTransition"),
                    void 0 === e.perspectiveProperty &&
                        void 0 === e.webkitPerspective &&
                        (i.animType = !1)),
                void 0 !== e.msTransform &&
                    ((i.animType = "msTransform"),
                    (i.transformType = "-ms-transform"),
                    (i.transitionType = "msTransition"),
                    void 0 === e.msTransform && (i.animType = !1)),
                void 0 !== e.transform &&
                    !1 !== i.animType &&
                    ((i.animType = "transform"),
                    (i.transformType = "transform"),
                    (i.transitionType = "transition")),
                (i.transformsEnabled =
                    i.options.useTransform &&
                    null !== i.animType &&
                    !1 !== i.animType);
        }),
        (e.prototype.setSlideClasses = function (i) {
            var e,
                t,
                o,
                s,
                n = this;
            if (
                ((t = n.$slider
                    .find(".slick-slide")
                    .removeClass("slick-active slick-center slick-current")
                    .attr("aria-hidden", "true")),
                n.$slides.eq(i).addClass("slick-current"),
                !0 === n.options.centerMode)
            ) {
                var r = n.options.slidesToShow % 2 == 0 ? 1 : 0;
                (e = Math.floor(n.options.slidesToShow / 2)),
                    !0 === n.options.infinite &&
                        (i >= e && i <= n.slideCount - 1 - e
                            ? n.$slides
                                  .slice(i - e + r, i + e + 1)
                                  .addClass("slick-active")
                                  .attr("aria-hidden", "false")
                            : ((o = n.options.slidesToShow + i),
                              t
                                  .slice(o - e + 1 + r, o + e + 2)
                                  .addClass("slick-active")
                                  .attr("aria-hidden", "false")),
                        0 === i
                            ? t
                                  .eq(t.length - 1 - n.options.slidesToShow)
                                  .addClass("slick-center")
                            : i === n.slideCount - 1 &&
                              t
                                  .eq(n.options.slidesToShow)
                                  .addClass("slick-center")),
                    n.$slides.eq(i).addClass("slick-center");
            } else
                i >= 0 && i <= n.slideCount - n.options.slidesToShow
                    ? n.$slides
                          .slice(i, i + n.options.slidesToShow)
                          .addClass("slick-active")
                          .attr("aria-hidden", "false")
                    : t.length <= n.options.slidesToShow
                    ? t.addClass("slick-active").attr("aria-hidden", "false")
                    : ((s = n.slideCount % n.options.slidesToShow),
                      (o =
                          !0 === n.options.infinite
                              ? n.options.slidesToShow + i
                              : i),
                      n.options.slidesToShow == n.options.slidesToScroll &&
                      n.slideCount - i < n.options.slidesToShow
                          ? t
                                .slice(o - (n.options.slidesToShow - s), o + s)
                                .addClass("slick-active")
                                .attr("aria-hidden", "false")
                          : t
                                .slice(o, o + n.options.slidesToShow)
                                .addClass("slick-active")
                                .attr("aria-hidden", "false"));
            ("ondemand" !== n.options.lazyLoad &&
                "anticipated" !== n.options.lazyLoad) ||
                n.lazyLoad();
        }),
        (e.prototype.setupInfinite = function () {
            var e,
                t,
                o,
                s = this;
            if (
                (!0 === s.options.fade && (s.options.centerMode = !1),
                !0 === s.options.infinite &&
                    !1 === s.options.fade &&
                    ((t = null), s.slideCount > s.options.slidesToShow))
            ) {
                for (
                    o =
                        !0 === s.options.centerMode
                            ? s.options.slidesToShow + 1
                            : s.options.slidesToShow,
                        e = s.slideCount;
                    e > s.slideCount - o;
                    e -= 1
                )
                    (t = e - 1),
                        i(s.$slides[t])
                            .clone(!0)
                            .attr("id", "")
                            .attr("data-slick-index", t - s.slideCount)
                            .prependTo(s.$slideTrack)
                            .addClass("slick-cloned");
                for (e = 0; e < o + s.slideCount; e += 1)
                    (t = e),
                        i(s.$slides[t])
                            .clone(!0)
                            .attr("id", "")
                            .attr("data-slick-index", t + s.slideCount)
                            .appendTo(s.$slideTrack)
                            .addClass("slick-cloned");
                s.$slideTrack
                    .find(".slick-cloned")
                    .find("[id]")
                    .each(function () {
                        i(this).attr("id", "");
                    });
            }
        }),
        (e.prototype.interrupt = function (i) {
            var e = this;
            i || e.autoPlay(), (e.interrupted = i);
        }),
        (e.prototype.selectHandler = function (e) {
            var t = this,
                o = i(e.target).is(".slick-slide")
                    ? i(e.target)
                    : i(e.target).parents(".slick-slide"),
                s = parseInt(o.attr("data-slick-index"));
            s || (s = 0),
                t.slideCount <= t.options.slidesToShow
                    ? t.slideHandler(s, !1, !0)
                    : t.slideHandler(s);
        }),
        (e.prototype.slideHandler = function (i, e, t) {
            var o,
                s,
                n,
                r,
                l,
                d = null,
                a = this;
            if (
                ((e = e || !1),
                !(
                    (!0 === a.animating && !0 === a.options.waitForAnimate) ||
                    (!0 === a.options.fade && a.currentSlide === i)
                ))
            )
                if (
                    (!1 === e && a.asNavFor(i),
                    (o = i),
                    (d = a.getLeft(o)),
                    (r = a.getLeft(a.currentSlide)),
                    (a.currentLeft = null === a.swipeLeft ? r : a.swipeLeft),
                    !1 === a.options.infinite &&
                        !1 === a.options.centerMode &&
                        (i < 0 ||
                            i > a.getDotCount() * a.options.slidesToScroll))
                )
                    !1 === a.options.fade &&
                        ((o = a.currentSlide),
                        !0 !== t
                            ? a.animateSlide(r, function () {
                                  a.postSlide(o);
                              })
                            : a.postSlide(o));
                else if (
                    !1 === a.options.infinite &&
                    !0 === a.options.centerMode &&
                    (i < 0 || i > a.slideCount - a.options.slidesToScroll)
                )
                    !1 === a.options.fade &&
                        ((o = a.currentSlide),
                        !0 !== t
                            ? a.animateSlide(r, function () {
                                  a.postSlide(o);
                              })
                            : a.postSlide(o));
                else {
                    if (
                        (a.options.autoplay && clearInterval(a.autoPlayTimer),
                        (s =
                            o < 0
                                ? a.slideCount % a.options.slidesToScroll != 0
                                    ? a.slideCount -
                                      (a.slideCount % a.options.slidesToScroll)
                                    : a.slideCount + o
                                : o >= a.slideCount
                                ? a.slideCount % a.options.slidesToScroll != 0
                                    ? 0
                                    : o - a.slideCount
                                : o),
                        (a.animating = !0),
                        a.$slider.trigger("beforeChange", [
                            a,
                            a.currentSlide,
                            s,
                        ]),
                        (n = a.currentSlide),
                        (a.currentSlide = s),
                        a.setSlideClasses(a.currentSlide),
                        a.options.asNavFor &&
                            (l = (l = a.getNavTarget()).slick("getSlick"))
                                .slideCount <= l.options.slidesToShow &&
                            l.setSlideClasses(a.currentSlide),
                        a.updateDots(),
                        a.updateArrows(),
                        !0 === a.options.fade)
                    )
                        return (
                            !0 !== t
                                ? (a.fadeSlideOut(n),
                                  a.fadeSlide(s, function () {
                                      a.postSlide(s);
                                  }))
                                : a.postSlide(s),
                            void a.animateHeight()
                        );
                    !0 !== t
                        ? a.animateSlide(d, function () {
                              a.postSlide(s);
                          })
                        : a.postSlide(s);
                }
        }),
        (e.prototype.startLoad = function () {
            var i = this;
            !0 === i.options.arrows &&
                i.slideCount > i.options.slidesToShow &&
                (i.$prevArrow.hide(), i.$nextArrow.hide()),
                !0 === i.options.dots &&
                    i.slideCount > i.options.slidesToShow &&
                    i.$dots.hide(),
                i.$slider.addClass("slick-loading");
        }),
        (e.prototype.swipeDirection = function () {
            var i,
                e,
                t,
                o,
                s = this;
            return (
                (i = s.touchObject.startX - s.touchObject.curX),
                (e = s.touchObject.startY - s.touchObject.curY),
                (t = Math.atan2(e, i)),
                (o = Math.round((180 * t) / Math.PI)) < 0 &&
                    (o = 360 - Math.abs(o)),
                o <= 45 && o >= 0
                    ? !1 === s.options.rtl
                        ? "left"
                        : "right"
                    : o <= 360 && o >= 315
                    ? !1 === s.options.rtl
                        ? "left"
                        : "right"
                    : o >= 135 && o <= 225
                    ? !1 === s.options.rtl
                        ? "right"
                        : "left"
                    : !0 === s.options.verticalSwiping
                    ? o >= 35 && o <= 135
                        ? "down"
                        : "up"
                    : "vertical"
            );
        }),
        (e.prototype.swipeEnd = function (i) {
            var e,
                t,
                o = this;
            if (((o.dragging = !1), (o.swiping = !1), o.scrolling))
                return (o.scrolling = !1), !1;
            if (
                ((o.interrupted = !1),
                (o.shouldClick = !(o.touchObject.swipeLength > 10)),
                void 0 === o.touchObject.curX)
            )
                return !1;
            if (
                (!0 === o.touchObject.edgeHit &&
                    o.$slider.trigger("edge", [o, o.swipeDirection()]),
                o.touchObject.swipeLength >= o.touchObject.minSwipe)
            ) {
                switch ((t = o.swipeDirection())) {
                    case "left":
                    case "down":
                        (e = o.options.swipeToSlide
                            ? o.checkNavigable(
                                  o.currentSlide + o.getSlideCount()
                              )
                            : o.currentSlide + o.getSlideCount()),
                            (o.currentDirection = 0);
                        break;
                    case "right":
                    case "up":
                        (e = o.options.swipeToSlide
                            ? o.checkNavigable(
                                  o.currentSlide - o.getSlideCount()
                              )
                            : o.currentSlide - o.getSlideCount()),
                            (o.currentDirection = 1);
                }
                "vertical" != t &&
                    (o.slideHandler(e),
                    (o.touchObject = {}),
                    o.$slider.trigger("swipe", [o, t]));
            } else
                o.touchObject.startX !== o.touchObject.curX &&
                    (o.slideHandler(o.currentSlide), (o.touchObject = {}));
        }),
        (e.prototype.swipeHandler = function (i) {
            var e = this;
            if (
                !(
                    !1 === e.options.swipe ||
                    ("ontouchend" in document && !1 === e.options.swipe) ||
                    (!1 === e.options.draggable &&
                        -1 !== i.type.indexOf("mouse"))
                )
            )
                switch (
                    ((e.touchObject.fingerCount =
                        i.originalEvent && void 0 !== i.originalEvent.touches
                            ? i.originalEvent.touches.length
                            : 1),
                    (e.touchObject.minSwipe =
                        e.listWidth / e.options.touchThreshold),
                    !0 === e.options.verticalSwiping &&
                        (e.touchObject.minSwipe =
                            e.listHeight / e.options.touchThreshold),
                    i.data.action)
                ) {
                    case "start":
                        e.swipeStart(i);
                        break;
                    case "move":
                        e.swipeMove(i);
                        break;
                    case "end":
                        e.swipeEnd(i);
                }
        }),
        (e.prototype.swipeMove = function (i) {
            var e,
                t,
                o,
                s,
                n,
                r,
                l = this;
            return (
                (n =
                    void 0 !== i.originalEvent
                        ? i.originalEvent.touches
                        : null),
                !(!l.dragging || l.scrolling || (n && 1 !== n.length)) &&
                    ((e = l.getLeft(l.currentSlide)),
                    (l.touchObject.curX =
                        void 0 !== n ? n[0].pageX : i.clientX),
                    (l.touchObject.curY =
                        void 0 !== n ? n[0].pageY : i.clientY),
                    (l.touchObject.swipeLength = Math.round(
                        Math.sqrt(
                            Math.pow(
                                l.touchObject.curX - l.touchObject.startX,
                                2
                            )
                        )
                    )),
                    (r = Math.round(
                        Math.sqrt(
                            Math.pow(
                                l.touchObject.curY - l.touchObject.startY,
                                2
                            )
                        )
                    )),
                    !l.options.verticalSwiping && !l.swiping && r > 4
                        ? ((l.scrolling = !0), !1)
                        : (!0 === l.options.verticalSwiping &&
                              (l.touchObject.swipeLength = r),
                          (t = l.swipeDirection()),
                          void 0 !== i.originalEvent &&
                              l.touchObject.swipeLength > 4 &&
                              ((l.swiping = !0), i.preventDefault()),
                          (s =
                              (!1 === l.options.rtl ? 1 : -1) *
                              (l.touchObject.curX > l.touchObject.startX
                                  ? 1
                                  : -1)),
                          !0 === l.options.verticalSwiping &&
                              (s =
                                  l.touchObject.curY > l.touchObject.startY
                                      ? 1
                                      : -1),
                          (o = l.touchObject.swipeLength),
                          (l.touchObject.edgeHit = !1),
                          !1 === l.options.infinite &&
                              ((0 === l.currentSlide && "right" === t) ||
                                  (l.currentSlide >= l.getDotCount() &&
                                      "left" === t)) &&
                              ((o =
                                  l.touchObject.swipeLength *
                                  l.options.edgeFriction),
                              (l.touchObject.edgeHit = !0)),
                          !1 === l.options.vertical
                              ? (l.swipeLeft = e + o * s)
                              : (l.swipeLeft =
                                    e +
                                    o * (l.$list.height() / l.listWidth) * s),
                          !0 === l.options.verticalSwiping &&
                              (l.swipeLeft = e + o * s),
                          !0 !== l.options.fade &&
                              !1 !== l.options.touchMove &&
                              (!0 === l.animating
                                  ? ((l.swipeLeft = null), !1)
                                  : void l.setCSS(l.swipeLeft))))
            );
        }),
        (e.prototype.swipeStart = function (i) {
            var e,
                t = this;
            if (
                ((t.interrupted = !0),
                1 !== t.touchObject.fingerCount ||
                    t.slideCount <= t.options.slidesToShow)
            )
                return (t.touchObject = {}), !1;
            void 0 !== i.originalEvent &&
                void 0 !== i.originalEvent.touches &&
                (e = i.originalEvent.touches[0]),
                (t.touchObject.startX = t.touchObject.curX =
                    void 0 !== e ? e.pageX : i.clientX),
                (t.touchObject.startY = t.touchObject.curY =
                    void 0 !== e ? e.pageY : i.clientY),
                (t.dragging = !0);
        }),
        (e.prototype.unfilterSlides = e.prototype.slickUnfilter =
            function () {
                var i = this;
                null !== i.$slidesCache &&
                    (i.unload(),
                    i.$slideTrack.children(this.options.slide).detach(),
                    i.$slidesCache.appendTo(i.$slideTrack),
                    i.reinit());
            }),
        (e.prototype.unload = function () {
            var e = this;
            i(".slick-cloned", e.$slider).remove(),
                e.$dots && e.$dots.remove(),
                e.$prevArrow &&
                    e.htmlExpr.test(e.options.prevArrow) &&
                    e.$prevArrow.remove(),
                e.$nextArrow &&
                    e.htmlExpr.test(e.options.nextArrow) &&
                    e.$nextArrow.remove(),
                e.$slides
                    .removeClass(
                        "slick-slide slick-active slick-visible slick-current"
                    )
                    .attr("aria-hidden", "true")
                    .css("width", "");
        }),
        (e.prototype.unslick = function (i) {
            var e = this;
            e.$slider.trigger("unslick", [e, i]), e.destroy();
        }),
        (e.prototype.updateArrows = function () {
            var i = this;
            Math.floor(i.options.slidesToShow / 2),
                !0 === i.options.arrows &&
                    i.slideCount > i.options.slidesToShow &&
                    !i.options.infinite &&
                    (i.$prevArrow
                        .removeClass("slick-disabled")
                        .attr("aria-disabled", "false"),
                    i.$nextArrow
                        .removeClass("slick-disabled")
                        .attr("aria-disabled", "false"),
                    0 === i.currentSlide
                        ? (i.$prevArrow
                              .addClass("slick-disabled")
                              .attr("aria-disabled", "true"),
                          i.$nextArrow
                              .removeClass("slick-disabled")
                              .attr("aria-disabled", "false"))
                        : i.currentSlide >=
                              i.slideCount - i.options.slidesToShow &&
                          !1 === i.options.centerMode
                        ? (i.$nextArrow
                              .addClass("slick-disabled")
                              .attr("aria-disabled", "true"),
                          i.$prevArrow
                              .removeClass("slick-disabled")
                              .attr("aria-disabled", "false"))
                        : i.currentSlide >= i.slideCount - 1 &&
                          !0 === i.options.centerMode &&
                          (i.$nextArrow
                              .addClass("slick-disabled")
                              .attr("aria-disabled", "true"),
                          i.$prevArrow
                              .removeClass("slick-disabled")
                              .attr("aria-disabled", "false")));
        }),
        (e.prototype.updateDots = function () {
            var i = this;
            null !== i.$dots &&
                (i.$dots.find("li").removeClass("slick-active").end(),
                i.$dots
                    .find("li")
                    .eq(Math.floor(i.currentSlide / i.options.slidesToScroll))
                    .addClass("slick-active"));
        }),
        (e.prototype.visibility = function () {
            var i = this;
            i.options.autoplay &&
                (document[i.hidden]
                    ? (i.interrupted = !0)
                    : (i.interrupted = !1));
        }),
        (i.fn.slick = function () {
            var i,
                t,
                o = this,
                s = arguments[0],
                n = Array.prototype.slice.call(arguments, 1),
                r = o.length;
            for (i = 0; i < r; i++)
                if (
                    ("object" == typeof s || void 0 === s
                        ? (o[i].slick = new e(o[i], s))
                        : (t = o[i].slick[s].apply(o[i].slick, n)),
                    void 0 !== t)
                )
                    return t;
            return o;
        });
});
///Slick js core End

// threesixty build
(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.threesixty = factory());
})(this, (function () { 'use strict';

	function getDefaultExportFromCjs (x) {
		return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
	}

	var lib = {};

	var hasRequiredLib;
	function requireLib() {
	  if (hasRequiredLib) return lib;
	  hasRequiredLib = 1;
	  Object.defineProperty(lib, "__esModule", {
	    value: true
	  });
	  lib["default"] = void 0;
	  var threesixty = function threesixty(container, images, options) {
	    if (!container) {
	      throw new Error('A container argument is required');
	    }
	    if (!images) {
	      throw new Error('An images argument is required');
	    }
	    var defaults = {
	      interactive: true,
	      reverse: false,
	      currentFrame: 0
	    };
	    var o = Object.assign({}, defaults, options);
	    var totalFrames = images.length;
	    var mouseX = 0;
	    var oldMouseX = 0; //------------------------------------------------------------------------------
	    //
	    //  Initialisation
	    //
	    //------------------------------------------------------------------------------

	    var init = function init() {
	      preloadimages(images, start);
	    };
	    var preloadimages = function preloadimages(sourceImages, cb) {
	      var total = sourceImages.length;
	      var loaded = 0;
	      var onload = function onload() {
	        if (++loaded >= total) cb(finalImages);
	      };
	      var finalImages = sourceImages.map(function (item) {
	        var image = new Image();
	        image.src = item;
	        image.onload = onload;
	        image.onerror = onload;
	        image.onabort = onload;
	        image.draggable = false;
	        return image;
	      });
	    };
	    var start = function start(loadedImages) {
	      images = loadedImages;
	      emptyDomNode(container);
	      container.appendChild(images[o.currentFrame]);
	      if (o.interactive) {
	        initListeners();
	      }
	    }; //------------------------------------------------------------------------------
	    //
	    //  Events
	    //
	    //------------------------------------------------------------------------------

	    var initListeners = function initListeners() {
	      container.addEventListener('touchstart', startDrag, {
	        passive: true
	      });
	      container.addEventListener('mousedown', startDrag);
	    };
	    var drag = function drag(e) {
	      if (!isTouchEvent(e)) {
	        e.preventDefault();
	      }
	      mouseX = e.pageX !== undefined ? e.pageX : e.changedTouches[0].pageX;
	      if (o.reverse) {
	        if (mouseX > oldMouseX) {
	          previous();
	        } else if (mouseX < oldMouseX) {
	          next();
	        }
	      } else {
	        if (mouseX < oldMouseX) {
	          previous();
	        } else if (mouseX > oldMouseX) {
	          next();
	        }
	      }
	      oldMouseX = mouseX;
	    };
	    var startDrag = function startDrag(e) {
	      if (!isTouchEvent(e)) {
	        e.preventDefault();
	      }
	      document.addEventListener('touchmove', drag, {
	        passive: true
	      });
	      document.addEventListener('mousemove', drag);
	      document.addEventListener('touchend', stopDrag);
	      document.addEventListener('mouseup', stopDrag);
	    };
	    var stopDrag = function stopDrag(e) {
	      if (!isTouchEvent(e)) {
	        e.preventDefault();
	      }
	      document.removeEventListener('touchmove', drag);
	      document.removeEventListener('mousemove', drag);
	      document.addEventListener('touchend', stopDrag, {
	        passive: true
	      });
	      document.addEventListener('mouseup', stopDrag);
	    }; //------------------------------------------------------------------------------
	    //
	    //  Sequence management
	    //
	    //------------------------------------------------------------------------------

	    var replaceImage = function replaceImage() {
	      container.replaceChild(images[o.currentFrame], container.childNodes[0]);
	    };
	    var previous = function previous() {
	      o.currentFrame--;
	      if (o.currentFrame < 0) o.currentFrame = totalFrames - 1;
	      replaceImage();
	    };
	    var next = function next() {
	      o.currentFrame++;
	      if (o.currentFrame === totalFrames) o.currentFrame = 0;
	      replaceImage();
	    };
	    var isInteractive = function isInteractive() {
	      return o.interactive;
	    };
	    var isReverse = function isReverse() {
	      return o.reverse;
	    };
	    var getCurrentFrame = function getCurrentFrame() {
	      return o.currentFrame;
	    }; //------------------------------------------------------------------------------
	    //
	    //  API
	    //
	    //------------------------------------------------------------------------------

	    return {
	      init: init,
	      previous: previous,
	      next: next,
	      isInteractive: isInteractive,
	      isReverse: isReverse,
	      getCurrentFrame: getCurrentFrame
	    };
	  }; //------------------------------------------------------------------------------
	  //
	  //  Utilities
	  //
	  //------------------------------------------------------------------------------

	  var emptyDomNode = function emptyDomNode(element) {
	    if (element.hasChildNodes()) {
	      while (element.firstChild) {
	        element.removeChild(element.firstChild);
	      }
	    }
	  };
	  var isTouchEvent = function isTouchEvent(e) {
	    return e.touches;
	  };
	  var _default = threesixty;
	  lib["default"] = _default;
	  return lib;
	}

	var libExports = requireLib();
	var index = /*@__PURE__*/getDefaultExportFromCjs(libExports);

	return index;

}));
//# sourceMappingURL=threesixty.umd.js.map


// commonly used variables
const currentPageLink = window.location.href;

// adobe analytics setup
function triggerCustomAnalytics(s, overrides = {}) {
    try {
        if (typeof s !== "undefined" && typeof s.ta === "function") {
            Object.assign(s, {
                eVar14: "",
                eVar23: "",
                eVar19: "",
                eVar97: "",
                eVar64: "",
                events: "",

                ...overrides, // allow overrides
            });

            s.ta();
        } else {
            console.warn(
                "Adobe Analytics (s) object not ready or ta() missing"
            );
        }
    } catch (error) {
        console.error("Analytics tracking failed:", error);
    }
}
// adobe analytics setup

/* START OF EXTERNAL MAGNITE VLP */
// animated magnite vlp : floating CTAs start
class FLoatingCtas {
    constructor() {
        this.isMobile = false;
        this.floatingCtaContainerEl = null;
        this.init();
    }

    init() {
        document.addEventListener("DOMContentLoaded", () => {
            this.floatingCtaContainerEl = document.querySelector(
                ".alt-component-floatingCtas"
            );
            if (!this.floatingCtaContainerEl) {
                return;
            }

            const THRESHOLD = 100;
            window.addEventListener("scroll", () => {
                if (window.scrollY > THRESHOLD) {
                    this.floatingCtaContainerEl.classList.add("is-visible");
                } else {
                    this.floatingCtaContainerEl.classList.remove("is-visible");
                }
            });

            this.checkIfMobile();
            this.handleDesktopAndMobileView();
            this.handleScrollToTop();
            this.handleBurgerMenuClick();
            this.setupTaggingForCTA();
        });
    }

    checkIfMobile() {
        this.isMobile = window.matchMedia("(max-width: 600px)").matches;
    }

    handleDesktopAndMobileView() {
        if (this.isMobile) {
            this.floatingCtaContainerEl
                .querySelector(".desktop")
                .classList.add("hide");
            this.floatingCtaContainerEl
                .querySelector(".mobile")
                .classList.remove("hide");
        } else {
            this.floatingCtaContainerEl
                .querySelector(".mobile")
                .classList.add("hide");
            this.floatingCtaContainerEl
                .querySelector(".desktop")
                .classList.remove("hide");
        }
    }

    handleBurgerMenuClick() {
        if (this.isMobile) {
            const burgerMenuBtn =
                this.floatingCtaContainerEl.querySelector("button.burger-menu");
            const closeBurgerMenuBtn =
                this.floatingCtaContainerEl.querySelector(
                    "button.close-burger-menu"
                );
            const ctaCardEl =
                this.floatingCtaContainerEl.querySelector(".cta-list-card");

            burgerMenuBtn.addEventListener("click", () => {
                burgerMenuBtn.classList.add("hide");
                closeBurgerMenuBtn.classList.remove("hide");
                ctaCardEl.classList.add("show");
            });

            closeBurgerMenuBtn.addEventListener("click", () => {
                burgerMenuBtn.classList.remove("hide");
                closeBurgerMenuBtn.classList.add("hide");
                ctaCardEl.classList.remove("show");
            });
        }
    }

    handleScrollToTop() {
        if (this.isMobile) {
            const scrollTopBtn = this.floatingCtaContainerEl.querySelector(
                "button.scroll-to-top"
            );
            scrollTopBtn?.addEventListener("click", () => {
                window.scrollTo({
                    top: 0,
                    behavior: "smooth", // Smooth scrolling behavior
                });
            });
        }
    }

    setupTaggingForCTA() {
        // tagging for desktop CTAs
        const desktopCtas = this.floatingCtaContainerEl.querySelectorAll(
            ".cta-list.desktop .cta"
        );

        desktopCtas.forEach((cta, index) => {
            cta.addEventListener("click", () => {
                const textContent = cta.textContent.replace(/\n/g, "").trim();

                if (!window.s) {
                    return;
                }

                const s = window.s;
                const prevUseBeacon = s.useBeacon;

                s.useBeacon = true;

                try {
                    triggerCustomAnalytics(window.s, {
                        eVar14: `${textContent}|${cta.href}|${currentPageLink}|floating cta`,
                        eVar23: `button-click|${textContent}`,
                        eVar64: `c${index + 1}_floating cta`,
                    });
                } catch (error) {
                    console.log(error.message);
                }

                s.useBeacon = prevUseBeacon;
            });
        });

        // tagging for mobile CTAs
        const mobilePrimaryCta = this.floatingCtaContainerEl.querySelector(
            ".cta-list.mobile .cta.primary-cta"
        );
        const mobilePrimaryText = mobilePrimaryCta.textContent;
        mobilePrimaryCta.addEventListener("click", () => {
            if (!window.s) {
                return;
            }

            const s = window.s;
            const prevUseBeacon = s.useBeacon;

            s.useBeacon = true; // temporarily enable beacon
            try {
                triggerCustomAnalytics(window.s, {
                    eVar14: `${mobilePrimaryText}|${mobilePrimaryCta.href}|${currentPageLink}|floating cta`,
                    eVar23: `button-click|${mobilePrimaryText?.trim()}`,
                    eVar64: `c1_floating cta`,
                });
            } catch (error) {
                console.log(error.message);
            }
            s.useBeacon = prevUseBeacon;
        });

        const floatingCardCtas = this.floatingCtaContainerEl.querySelectorAll(
            ".cta-list.mobile .cta-list-card ul a"
        );
        floatingCardCtas.forEach((cta, idx) => {
            cta.addEventListener("click", () => {
                 if (!window.s) {
                    return;
                }

                const s = window.s;
                const prevUseBeacon = s.useBeacon;

                s.useBeacon = true; // temporarily enable beacon
                try {
                    const ctaText = cta.textContent?.trim();
                    // cta with text 'Download Brochure' is already tagged by adobe-tracking.js
                    if (ctaText.toLowerCase() === 'download brochure') {
                        window.s.eVar14= `${ctaText}|${cta.href}|${currentPageLink}|floating cta`;
                        window.s.eVar23= `button-click|${ctaText?.trim()}`;
                        window.s.eVar64= `c${idx + 2}_floating cta`;
                        return;
                    }
                    triggerCustomAnalytics(window.s, {
                        eVar14: `${ctaText}|${cta.href}|${currentPageLink}|floating cta`,
                        eVar23: `button-click|${ctaText?.trim()}`,
                        eVar64: `c${idx + 2}_floating cta`,
                    });
                } catch (error) {
                    console.log(error.message);
                }
                s.useBeacon = prevUseBeacon;
            });
        });
    }
}
const floatingCtas = new FLoatingCtas();
// animated magnite vlp : floating CTAs end

let tagId;

let analyticsFired = false;
const taggedSections = new Set();

// animated magnite vlp : feature banner carousel start
function initFeatureBannerCarousel($wrapper) {
    // dont trigger inside backend editor
    if ($(".alt-editor").length) return;

    const $slider = $wrapper.find(".slides-container");

    const autoplayDuration = 6000;
    const speed = 750;

    let $paginationItems = $(); // jQuery collection of li
    let isPaused = false;

    function initializeSlick() {
        if (!$slider.length) return;

        if (!$slider.hasClass("slick-initialized")) {
            $slider.slick({
                rtl: document.documentElement.lang === 'ar',
                centerMode: true,
                // centerPadding: '60px',
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: autoplayDuration,
                arrows: false,
                infinite: true,
                pauseOnFocus: false,
                pauseOnHover: false,
                speed: speed,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            centerMode: false,
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        },
                    },
                ],
            });
        }

        /* const desktopBreakpoint = 768;
        function isDesktop() {
            return window.innerWidth > desktopBreakpoint;
        }

        $slider.on("afterChange", function (event, slick, currentSlide) {
            if (!isDesktop()) return;

            const isLastSlide = currentSlide === slick.slideCount - 1;

            $slider.slick(
                "slickSetOption",
                "slidesToShow",
                isLastSlide ? 1 : 1.04,
                true
            );
        }); */
    }

    function createSpinner() {
        const $spinner = $("<span/>", { class: "pagination-spinner" }).hide();

        const $svg = $(
            document.createElementNS("http://www.w3.org/2000/svg", "svg")
        )
            .attr("viewBox", "0 0 36 36")
            .addClass("circular-progress");

        const $circle = $(
            document.createElementNS("http://www.w3.org/2000/svg", "circle")
        )
            .attr({ cx: "18", cy: "18", r: "16" })
            .addClass("progress-ring");

        $svg.append($circle);
        $spinner.append($svg);

        return $spinner;
    }

    function setupPagination() {
        const slick = $slider.slick("getSlick");
        const totalSlides = slick ? slick.slideCount : 0;

        const $container = $wrapper.find("ul.count-listings");
        $container.empty();

        $paginationItems = $(); // reset

        for (let idx = 0; idx < totalSlides; idx++) {
            const $li = $("<li/>", {
                class: "count",
                "data-index": idx,
            });

            const $content = $("<span/>", {
                class: "count-content",
                text: idx + 1,
            });

            const $spinner = createSpinner();

            const $pauseIcon = $("<span/>", { class: "pause-icon", text: "||" }).hide();
            const $playIcon = $("<span/>", { class: "play-icon", text: "▶" }).hide();
            $li.append($content, $spinner, $pauseIcon, $playIcon);
            $container.append($li);

            $paginationItems = $paginationItems.add($li);
        }
    }

    function startProgress($li) {
        const $spinner = $li.find(".pagination-spinner");
        const $circle = $spinner.find(".progress-ring");
        const $content = $li.find(".count-content");

        $content.hide();
        $spinner.show();

        $li.find(".pause-icon").show();
        $li.find(".play-icon").hide();

        // Clear any existing animation on this item
        const existingId = $li.data("progressRafId");
        if (existingId) {
            cancelAnimationFrame(existingId);
        }

        // Reset progress
        $circle.css("strokeDashoffset", "100");

        const startTime = performance.now();
        const duration = autoplayDuration;

        function animate(now) {
            const elapsed = now - startTime;
            const progress = Math.min(elapsed / duration, 1);
            $circle.css("strokeDashoffset", 100 - (progress * 100));

            if (progress < 1) {
                $li.data("progressRafId", requestAnimationFrame(animate));
            }
        }

        $li.data("progressRafId", requestAnimationFrame(animate));
    }

    function stopProgress($li) {
        const id = $li.data("progressRafId");
        if (id) {
            cancelAnimationFrame(id);
            $li.removeData("progressRafId");
        }

        $li.find(".pagination-spinner").hide();
        $li.find(".count-content").show();
        $li.find(".pause-icon").hide();
        $li.find(".play-icon").hide();
    }

    function clearAllProgress() {
        $paginationItems.each(function () {
            const $li = $(this);
            stopProgress($li);
            $li.removeClass("active paused");
        });
    }

    function setActivePagination(index) {
        clearAllProgress();

        const $active = $paginationItems.eq(index);
        $active.addClass("active");
        startProgress($active);
    }

    function bindSlickEvents() {
        if (!$slider.length) return;

        // initial highlight after slick is ready
        setTimeout(function () {
            if (!$slider.hasClass("slick-initialized")) return;
            setActivePagination($slider.slick("slickCurrentSlide"));
        }, 100);

        $slider.on("beforeChange", function () {
            clearAllProgress();
        });

        $slider.on("afterChange", function (event, slick, currentSlide) {
            // only one active
            $paginationItems.removeClass("active");
            setActivePagination(currentSlide);
        });
    }

    function bindPaginationClicks() {
        $wrapper.on("click", "ul.count-listings li.count", function () {
            const $this = $(this);
            const index = Number($this.data("index"));
            const isActiveDot = $this.is(".active");

            if (isActiveDot && $slider.hasClass("slick-initialized")) {
                isPaused = !isPaused;

                if (isPaused) {
                    $slider.slick("slickPause");
                    stopProgress($this);
                    $this.find(".count-content").hide();
                    $this.find(".pause-icon").hide();
                    $this.find(".play-icon").show();
                    $this.addClass("paused");
                } else {
                    $slider.slick("slickPlay");
                    $this.find(".play-icon").hide();
                    $this.find(".pause-icon").show();
                    $this.removeClass("paused");
                    startProgress($this);
                }
            } else if (!isActiveDot) {
                clearAllProgress();

                if ($slider.hasClass("slick-initialized")) {
                    if (isPaused) {
                        $slider.slick("slickPlay");
                        isPaused = false;
                    }
                    $slider.slick("slickGoTo", index);
                }
            }
        });
    }

    setTimeout(() => {
        initializeSlick();
        setTimeout(() => {
            setupPagination();
            bindPaginationClicks();
            bindSlickEvents();

            const carouselTitle = $wrapper.find(".feature-title .title").text();
            setupSlideChangeTagging($wrapper, carouselTitle, $slider);
        }, 300);
    }, 10);
}

$(function () {
    $(".alt-component-featureBannerCarousel").each(function () {
        initFeatureBannerCarousel($(this));
    });
});
// animated magnite vlp : feature banner carousel end

// SETUP FOR SCROLL TAGGING
const currentHash = window.location.hash; // "#technology"
let pageLoadedWithNavLink = false;
let userScrolled = false;

function checkIfPageLoadedWithNavLink() {
    const allNavLinks = document.querySelectorAll(
        ".alt-component-stickyNavbar .desk-nav a"
    );

    for (const a of allNavLinks) {
        if (a.getAttribute("href") === currentHash) {
            pageLoadedWithNavLink = true;
            break;
        }
    }
}

checkIfPageLoadedWithNavLink();
console.log("pageLoadedWithNavLink -> ", pageLoadedWithNavLink);
console.log("userScrolled -> ", userScrolled);
// scrolled sections will be recorded to avoid duplicate tagging entries
const scrollingTracked = [];

// animated magnite vlp : sticky navbar start
class VlpStickyNavbar {
    constructor() {
        this.init();
        this.stickyNavbarEl = null;
        this.allNavlinks = null;
        this.isMobile = false;
    }

    init() {
        document.addEventListener("DOMContentLoaded", () => {
            this.stickyNavbarEl = document.querySelector(
                ".alt-component-stickyNavbar"
            );
            if (!this.stickyNavbarEl) {
                return;
            }

            // this.hideDefaultNavbar();
            this.checkIfMobile();
            this.applyPageSkin();

            if (this.isMobile) {
                this.allNavlinks =
                    this.stickyNavbarEl.querySelectorAll(".mobile-nav a");
                this.setPageScrollIntersectionObserver();
            } else {
                this.allNavlinks =
                    this.stickyNavbarEl.querySelectorAll(".desk-nav a");
            }
            // call after getting all navlinks and isMobile assigned
            this.setActiveSectionIntersectionObserver();
            this.setupTaggingForNavigationAnchors();
            this.setupTaggingForOffersCTA();
        });
    }

    setupTaggingForOffersCTA() {
        const offersCta = this.stickyNavbarEl.querySelector("a.offer-cta");
        offersCta.addEventListener("click", () => {
            const targetPageLink = offersCta.href;
            const textContent = offersCta.textContent.replace(/\n/g, "").trim();
            if (!window.s) {
                return;
            }

            const s = window.s;
            const prevUseBeacon = s.useBeacon;

            s.useBeacon = true; // temporarily enable beacon
            try {
                triggerCustomAnalytics(window.s, {
                    eVar14: `${textContent}|${targetPageLink}|${currentPageLink}|sticky navbar`,
                    eVar23: `button-click|${textContent} `,
                    eVar64: `c1_sticky navbar CTA`,
                });
            } catch (error) {
                console.log(error.message);
            }
            s.useBeacon = prevUseBeacon;
        });
    }

    checkIfMobile() {
        this.isMobile = screen.width <= 600 ? true : false;
    }

    hideDefaultNavbar() {
        // hide deafult navbar since vlp sticky navbar is used
        document.body.classList.add("hide-default-navbar");
        document.body.classList.add("hide-floating-panel");
    }

    applyPageSkin() {
        const applyBlackSkin =
            this.stickyNavbarEl.classList.contains("black-skin");
        if (applyBlackSkin) {
            document.body.classList.add("black-skin");
        } else {
            document.body.classList.remove("black-skin");
        }
    }
    /*
    setActiveSectionIntersectionObserver() {
        const vlpSections = document.querySelectorAll(".vlp-section");
        const navLinks = this.allNavlinks;

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        const id = entry.target.id;

                        navLinks?.forEach((link) => {
                            const linkHash = link.getAttribute("href");
                            link.classList.toggle(
                                "active",
                                linkHash === `#${id}`
                            );
                        });

                        // Track only the link that matches the intersecting section
                        const matchingLink = Array.from(navLinks).find(
                            (link) => link.getAttribute("href") === `#${id}`
                        );

                        if (matchingLink) {
                            const linkHash = `#${id}`;

                            // Only tag the target section (the one matching currentHash)
                            // do not tag sections that scroll into view during initial navigation
                            if (
                                pageLoadedWithNavLink &&
                                !userScrolled &&
                                linkHash !== currentHash
                            ) {
                                return; // Skip tagging for sections OTHER than the target
                            }

                            setTimeout(() => {
                                // Delay the scroll listener setup to avoid catching the initial auto-scroll
                                window.addEventListener(
                                    "scroll",
                                    () => {
                                        userScrolled = true;
                                        console.log(
                                            "userScrolled on scroll event -> ",
                                            userScrolled
                                        );
                                    },
                                    { once: true }
                                );
                            }, 2000); // Give time for initial auto-scroll to complete

                            tagId = setInterval(() => {
                                // wait until analytics is available
                                if (!window.s) {
                                    return;
                                }

                                // ensure it runs only once
                                if (analyticsFired) {
                                    clearInterval(id);
                                    return;
                                }

                                const linkText = matchingLink.textContent;

                                if (!scrollingTracked.includes(linkText)) {
                                    scrollingTracked.push(linkText);

                                    console.log("trigger analytics -> ", {
                                        s: window.s,
                                        eVar23: "scrolling",
                                        eVar97: `${linkText}|${linkText} scrolled`,
                                    });

                                    triggerCustomAnalytics(window.s, {
                                        eVar23: "scrolling",
                                        eVar97: `${linkText}|${linkText} scrolled`,
                                    });

                                    analyticsFired = true;
                                    clearInterval(tagId);
                                }
                            }, 1000);
                        }
                    }
                });
            },
            {
                threshold: 0.6, // section is considered active when 60% visible
            }
        );

        vlpSections.forEach((section) => observer.observe(section));
    } */

    setActiveSectionIntersectionObserver() {
        const vlpSections = document.querySelectorAll(".vlp-section");
        const navLinks = this.allNavlinks;

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (!entry.isIntersecting) return;

                    const sectionId = entry.target.id;
                    const linkHash = `#${sectionId}`;

                    // update active nav state
                    navLinks?.forEach((link) => {
                        link.classList.toggle(
                            "active",
                            link.getAttribute("href") === linkHash
                        );
                    });

                    const matchingLink = Array.from(navLinks).find(
                        (link) => link.getAttribute("href") === linkHash
                    );

                    if (!matchingLink) return;

                    // ❌ Skip auto-scroll sections on initial load
                    if (
                        pageLoadedWithNavLink &&
                        !userScrolled &&
                        linkHash !== currentHash
                    ) {
                        return;
                    }

                    // ✅ already tagged → do nothing
                    if (taggedSections.has(sectionId)) return;

                    // ✅ only tag after user scroll
                    if (!userScrolled) return;

                    // ✅ analytics not ready yet
                    if (!window.s) return;

                    const linkText = matchingLink.textContent;

                    triggerCustomAnalytics(window.s, {
                        eVar23: "scrolling",
                        eVar97: `${linkText}|${linkText} scrolled`,
                    });

                    taggedSections.add(sectionId);

                    console.log("analytics fired for section:", sectionId);
                });
            },
            {
                threshold: 0.6,
            }
        );

        vlpSections.forEach((section) => observer.observe(section));
    }

    setPageScrollIntersectionObserver() {
        // Create the new element you want to insert after
        const guardElement = document.createElement("div");
        guardElement.classList.add("sticky-navbar-guard");
        guardElement.textContent = "";
        // Insert the 'guardElement' immediately after the sticky navbar
        this.stickyNavbarEl.after(guardElement);

        // scroll detection in mobile
        const sentinel = document.querySelector(".sticky-navbar-guard");

        const observer = new IntersectionObserver(
            ([entry]) => {
                this.stickyNavbarEl.classList.toggle(
                    "glass-bg",
                    !entry.isIntersecting
                );
            },
            { threshold: 0 }
        );

        observer.observe(sentinel);
    }

    setupTaggingForNavigationAnchors() {
        console.log(this.allNavlinks);
        this.allNavlinks.forEach((link, idx) => {
            link.addEventListener("click", (ev) => {
                const linkText = ev.currentTarget.textContent;
                console.log(linkText);
                if (!window.s) {
                    return;
                }

                const s = window.s;
                const prevUseBeacon = s.useBeacon;

                s.useBeacon = true; // temporarily enable beacon
                try {
                    triggerCustomAnalytics(window.s, {
                        eVar14: `${linkText}|sticky-navbar`,
                        eVar23: `anchor-link|${linkText}`,
                    });
                } catch (error) {
                    console.log(error.message);
                }
                s.useBeacon = prevUseBeacon;
            });
        });
    }
}

const stickyNavbar = new VlpStickyNavbar();
// animated magnite vlp : sticky navbar end

// animated magnite vlp: feature banner start
function initFeatureBanner() {
    setupFeatureBannerTagging();
}

function setupFeatureBannerTagging() {
    const componentAll = document.querySelectorAll(
        ".alt-component-featureBanner"
    );
    if (componentAll.length) {
        componentAll.forEach((component) => {
            const cta = component.querySelector(".feature-description a.cta");
            const componentName =
                component.querySelector(".feature-name")?.textContent;
            cta?.addEventListener("click", () => {
                const targetPageLink = cta.href;
                if (!window.s) {
                    return;
                }

                const s = window.s;
                const prevUseBeacon = s.useBeacon;

                s.useBeacon = true; // temporarily enable beacon
                try {
                    triggerCustomAnalytics(window.s, {
                        eVar14: `${cta.textContent}|${targetPageLink}|${currentPageLink}|sticky navbar`,
                        eVar23: `button-click|${cta.textContent} `,
                        eVar64: `c1_${componentName}`,
                    });
                } catch (error) {
                    console.log(error.message);
                }
                s.useBeacon = prevUseBeacon;
            });
        });
    }
}

window.addEventListener("DOMContentLoaded", initFeatureBanner);
// animated magnite vlp: feature banner end

// animated magnite vlp : feature banner with content start
function setupFeatureBannerWithContentTagging() {
    const componentAll = document.querySelectorAll(
        ".alt-component-featureBannerWithContent"
    );
    if (componentAll.length) {
        componentAll.forEach((component) => {
            const componentName =
                component.querySelector(".feature-name")?.textContent;
            const cta = component.querySelector(
                ".feature-description a.feature-cta"
            );
            cta?.addEventListener("click", () => {
                const textContent =
                    cta.querySelector(".cta-label")?.textContent;
                const targetPageLink = cta.href;

                if (!window.s) {
                    return;
                }

                const s = window.s;
                const prevUseBeacon = s.useBeacon;

                s.useBeacon = true; // temporarily enable beacon
                try {
                    triggerCustomAnalytics(window.s, {
                        eVar14: `${textContent}|${targetPageLink}|${currentPageLink}|Feature banner with content`,
                        eVar23: `button-click|${textContent} `,
                        eVar64: `c1_${componentName}`,
                    });
                } catch (error) {
                    console.log(error.message);
                }
                s.useBeacon = prevUseBeacon;
            });
        });
    }
}

window.addEventListener(
    "DOMContentLoaded",
    setupFeatureBannerWithContentTagging
);
// animated magnite vlp : feature banner with content end

/* animated magnite vlp :  Feature Grid Carousel start */
function initFeatureGridCarousel($wrapper) {
    const $slider = $wrapper.find(".slidesContainer");
    const speed = 1500;

    function initializeSlick() {
        if (!$slider.length) return;

        if (!$slider.hasClass("slick-initialized")) {
            $slider.slick({
                autoplay: false,
                autoplaySpeed: 3000,
                arrows: false,
                gap: 20,
                pauseOnFocus: false,
                pauseOnHover: false,
            });
        }
    }

    setTimeout(() => {
        initializeSlick();
    }, 10);
}

$(function () {
    $(".alt-component-featureGridCarousel").each(function () {
        initFeatureGridCarousel($(this));
    });
});
/* animated magnite vlp : Feature Grid Carousel start */

// animated magnite vlp : feature text image carousel start
function initFeatureTextImageCarousel($wrapper) {
    const isTopContent = $wrapper.hasClass("is-topContent");

    // dont trigger inside backend editor
    if ($(".alt-editor").length) return;

    const $slider = $wrapper.find(".slides-container");
    const speed = 750;

    const componentName = $wrapper.find(".slide-name").text();

    const documentLang = document.documentElement.lang;

    function initializeSlick() {
        if (!$slider.length) return;

        if (!$slider.hasClass("slick-initialized")) {
            $slider.slick({
                rtl: documentLang === 'ar',
                slidesToShow: isTopContent ? 2.1 : 1.1,
                slidesToScroll: 1,
                arrows: false,
                speed: speed,
                infinite: false,
                accessibility: false,
                adaptiveHeight: true,
                responsive: [
                    {
                        breakpoint: 1920, // bigger screen
                        settings: {
                            slidesToShow: isTopContent ? 2.1 : 1.1,
                            slidesToScroll: 1,
                        },
                    },
                    {
                        breakpoint: 1024, // tablet
                        settings: {
                            slidesToShow: isTopContent ? 2.1 : 1.1,
                            slidesToScroll: 1,
                        },
                    },
                    {
                        breakpoint: 600, // mobile
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        },
                    },
                ],
            });
        }

        // Update buttons after initialization and on every slide change
        $slider.on("afterChange", function () {
            updateButtons();
        });
    }

    function updateButtons() {
        if (!$slider.length) return;

        if (!$slider.hasClass("slick-initialized")) return;

        //INFO: Sometimes slickGetOption can return undefined during early init or resize.
        const slidesToShow =
            $slider.slick("slickGetOption", "slidesToShow") || 1;
        const current = $slider.slick("slickCurrentSlide");
        const total = $slider.find(".slick-slide:not(.slick-cloned)").length;

        $wrapper
            .find(".prev, .prev-mbl")
            .toggleClass("disabled", current === 0);
        $wrapper
            .find(".next, .next-mbl")
            .toggleClass("disabled", current >= total - slidesToShow);
    }

    function bindControls() {
        const safeNext = function () {
            if ($slider.hasClass("slick-initialized")) {
                $slider.slick("slickNext");
                updateButtons();
            }
        };

        const safePrev = function () {
            if ($slider.hasClass("slick-initialized")) {
                $slider.slick("slickPrev");
                updateButtons();
            }
        };

        $wrapper.find(".next, .next-mbl").on("click", safeNext);
        $wrapper.find(".prev, .prev-mbl").on("click", safePrev);
    }

    function setupCtaTagging() {
        $wrapper.find("a.slide-cta").each(function () {
            const $cta = $(this);

            $cta.off("click.ctaTagging").on("click.ctaTagging", function () {
                const textContent = $cta.find(".cta-label").text().trim();
                const targetPageLink = $cta.attr("href");

                if (!window.s) {
                    return;
                }

                const s = window.s;
                const prevUseBeacon = s.useBeacon;

                s.useBeacon = true;

                try {
                    triggerCustomAnalytics(window.s, {
                        eVar14: `${textContent}|${targetPageLink}|${currentPageLink}|Feature text and image carousel`,
                        eVar23: `button-click|${textContent}`,
                        eVar64: `c1_${componentName} carousel`,
                    });
                } catch (error) {
                    console.log(error.message);
                }

                s.useBeacon = prevUseBeacon;
            });
        });
    }

    function setupBeforeChangeTagging() {
        $slider.on(
            "beforeChange",
            function (_, slick, currentSlide, nextSlide) {
                if (nextSlide === currentSlide) return; // snap-back, no real change
                const sliderTitle = $wrapper
                    .find(".text-contents .slide-title")
                    .text();

                if (slick.autoplay) return;
                const direction =
                    nextSlide > currentSlide ? "next" : "previous";
                triggerCustomAnalytics(window.s, {
                    eVar23: `${sliderTitle}|${direction} slide`,
                });
            }
        );
    }

    setTimeout(() => {
        initializeSlick();
        setTimeout(() => {
            bindControls();
            updateButtons();
            setupCtaTagging();
            setupBeforeChangeTagging();
        }, 300);
    }, 10);
}

$(function () {
    $(".alt-component-featureTextImageCarousel").each(function () {
        initFeatureTextImageCarousel($(this));
    });
});
// animated magnite vlp : feature text image carousel end

// animated magnite vlp : feature magnite slider start
function initMagniteVehicleSlider($wrapper) {
    // dont trigger inside backend editor
    if ($(".alt-editor").length) return;

    const $slider = $wrapper.find(".vehicleSlider");
    const speed = 750;

    function initializeSlick() {
        if (!$slider.length) return;

        if (!$slider.hasClass("slick-initialized")) {
            $slider.slick({
                rtl: document.documentElement.lang === 'ar',
                slidesToShow: 4,
                slidesToScroll: 1,
                arrows: false,
                speed: speed,
                infinite: false,
                accessibility: false,
                adaptiveHeight: false,
                responsive: [
                    {
                        breakpoint: 1920, // large screen
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 1,
                        },
                    },
                    {
                        breakpoint: 1440, // large screen
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1,
                        },
                    },
                    {
                        breakpoint: 1024, // medium screen
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1,
                        },
                    },
                    {
                        breakpoint: 720, // tablet size screen
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                        },
                    },
                    {
                        breakpoint: 600, // mobile screens
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        },
                    },
                ],
            });
        }

        $slider.on("afterChange", function () {
            updateButtons();
        });
    }

    function updateButtons() {
        if (!$slider.length) return;
        if (!$slider.hasClass("slick-initialized")) return;

        // Sometimes slickGetOption can return undefined during early init or resize.
            const slidesToShow =
            $slider.slick("slickGetOption", "slidesToShow") || 1;

        const current = $slider.slick("slickCurrentSlide");
        const total = $slider.find(".slick-slide:not(.slick-cloned)").length;

        const $buttons = $wrapper.find(".prev, .prev-mbl, .next, .next-mbl");

        // No pagination possible.
            if (total <= slidesToShow) {
                $buttons.hide();
                return;
            }

        // Pagination is possible.
            $buttons.show();

        $wrapper
            .find(".prev, .prev-mbl")
            .toggleClass("disabled", current === 0);

        $wrapper
            .find(".next, .next-mbl")
            .toggleClass("disabled", current >= total - slidesToShow);
    }

    function bindControls() {
        if (!$slider.length) return;

        const safeNext = function () {
            if ($slider.hasClass("slick-initialized")) {
                $slider.slick("slickNext");
                updateButtons();
            }
        };

        const safePrev = function () {
            if ($slider.hasClass("slick-initialized")) {
                $slider.slick("slickPrev");
                updateButtons();
            }
        };

        $wrapper.find(".next, .next-mbl").on("click", safeNext);
        $wrapper.find(".prev, .prev-mbl").on("click", safePrev);
    }

    function setupCtaTagging() {
        // all slide's primary cta
        $wrapper.find(".slide a.ctaPrimary").each(function (index, _) {
            const $cta = $(this);
            const textContent = $cta.text();
            const targetPageLink = $cta.attr("href");

            $cta.click(() => {
                if (!window.s) {
                    return;
                }

                const s = window.s;
                const prevUseBeacon = s.useBeacon;

                s.useBeacon = true; // temporarily enable beacon
                try {
                    triggerCustomAnalytics(window.s, {
                        eVar14: `${textContent}|${targetPageLink}|${currentPageLink}|Vehicle Slider Slide`,
                        eVar23: `button-click|${textContent}`,
                        eVar64: `c1_Find Your Nissan Magnite slide ${index} cta`,
                    });
                } catch (error) {
                    console.log(error.message);
                }
                s.useBeacon = prevUseBeacon;
            });
        });

        // all slide's secondary cta
        $wrapper.find(".slide a.ctaSecondary").each(function (index, _) {
            const $cta = $(this);
            const textContent = $cta.text();
            const targetPageLink = $cta.attr("href");

            $cta.click(() => {
                if (!window.s) {
                    return;
                }

                const s = window.s;
                const prevUseBeacon = s.useBeacon;

                s.useBeacon = true; // temporarily enable beacon
                try {
                    triggerCustomAnalytics(window.s, {
                        eVar14: `${textContent}|${targetPageLink}|${currentPageLink}|Vehicle Slider Slide`,
                        eVar23: `button-click|${textContent}`,
                        eVar64: `c2_Find Your Nissan Magnite slide ${index} cta`,
                    });
                } catch (error) {
                    console.log(error.message);
                }
                s.useBeacon = prevUseBeacon;
            });
        });
    }

    function setupSlideChangeTagging() {
        $slider.on(
            "beforeChange",
            function (_, slick, currentSlide, nextSlide) {
                if (nextSlide === currentSlide) return; // snap-back, no real change
                const sliderTitle = $wrapper.find(".magnite-title").text();

                if (slick.autoplay) return;
                const direction =
                    nextSlide > currentSlide ? "next" : "previous";
                triggerCustomAnalytics(window.s, {
                    eVar23: `${sliderTitle}|${direction} slide`,
                });
            }
        );
    }

    setTimeout(() => {
        initializeSlick();
        setTimeout(() => {
            bindControls();
            updateButtons();
            setupCtaTagging();
            setupSlideChangeTagging();
        }, 300);
    }, 10);
}

// $(function () {

$(".alt-component-slider.is-magnite").each(function () {
    initMagniteVehicleSlider($(this));
});
// });

// view more and less toggle
$(document).ready(function () {
    const $slider = $(".alt-component-slider.is-magnite");

    const viewMoreLabel = $slider.data("viewmorelabel");
    const viewLessLabel = $slider.data("viewlesslabel");
    
    $(".alt-component-slider.is-magnite .feature-list").each(function () {
        const $list = $(this);
        const visibleCount = parseInt($list.data("visible-count"), 10) || 4;
        const $items = $list.find("li");
        const $toggleBtn = $list.next(".toggle-list");

        // If button missing or not enough items, do nothing
        if (!$toggleBtn.length || $items.length <= visibleCount) {
            $toggleBtn.hide();
            return;
        }

        // Initial state
        $items.slice(visibleCount).addClass("is-hidden");

        $toggleBtn.on("click", function () {
            console.log("clicked...");
            const isExpanded = $(this).attr("aria-expanded") === "true";

            $items.slice(visibleCount).toggleClass("is-hidden", isExpanded);

            $(this)
                .find(".label")
                .text(isExpanded ? viewMoreLabel :viewLessLabel);

            $(this).attr("aria-expanded", !isExpanded);
        });
    });
});
// animated magnite vlp : Vehicle Magnite slider end

// animated magnite vlp : latest offer slider start
function initLatestOfferSlider($wrapper) {
    // dont trigger inside backend editor
    if ($(".alt-editor").length) return;

    const $slider = $wrapper.find(".latest-offers-slider");
    const componentName = $wrapper.find(".latest-offers-title").text();

    function initializeSlick() {
        if (!$slider.length) return;
        if (!$slider.hasClass("slick-initialized")) {
            $slider.slick({
                rtl: document.documentElement.lang === 'ar',
                slidesToShow: 1.1,
                slidesToScroll: 1,
                arrows: false,
                infinite: false,
                accessibility: false,
                // adaptiveHeight: true
                responsive: [
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        },
                    },
                ],
            });
        }
    }

    function updateButtons() {
        if (!$slider.hasClass("slick-initialized")) return;

        const current = $slider.slick("slickCurrentSlide");
        const total = $slider.find(".slide").length;

        const $prevBtns = $wrapper.find(".prev, .prev-mbl");
        const $nextBtns = $wrapper.find(".next, .next-mbl");

        $prevBtns.toggleClass("disabled", current === 0);
        $nextBtns.toggleClass("disabled", current === total - 1);

        const hideNav = total <= 1;
        $prevBtns.toggleClass("hide", hideNav);
        $nextBtns.toggleClass("hide", hideNav);
    }

    function bindControls() {
        const safeNext = () => {
            if ($slider.hasClass("slick-initialized")) {
                $slider.slick("slickNext");
                updateButtons();
            }
        };

        const safePrev = () => {
            if ($slider.hasClass("slick-initialized")) {
                $slider.slick("slickPrev");
                updateButtons();
            }
        };

        $wrapper.find(".next, .next-mbl").on("click", safeNext);
        $wrapper.find(".prev, .prev-mbl").on("click", safePrev);
    }

    function setupCtaTagging() {
        // main cta
      const isMobile = screen.width <= 600;
        // main cta
      const latestOffersCtaEl = isMobile
        ? $wrapper.find("a.latest-offers-cta.is-mobile")
        : $wrapper.find("a.latest-offers-cta:not(.is-mobile)");
        if (latestOffersCtaEl) {
            const textContent = latestOffersCtaEl
                .find(".latest-offers-cta-label")
                .text().replace(/\s+/g, '');
            const targetPageLink = latestOffersCtaEl.attr("href");
            latestOffersCtaEl.click(() => {
                if (!window.s) {
                    return;
                }

                const s = window.s;
                const prevUseBeacon = s.useBeacon;

                s.useBeacon = true; // temporarily enable beacon
                try {
                    triggerCustomAnalytics(window.s, {
                        eVar14: `view all offers|${targetPageLink}|${currentPageLink}|Offers Slider`,
                        eVar23: `button-click|view all offers`,
                        eVar64: `c1_Offer Slider main cta`,
                    });
                } catch (error) {
                    console.log(error.message);
                }
                s.useBeacon = prevUseBeacon;
            });
        }

        // per slide cta
        $wrapper
            .find(".slide a.latest-offers-cta-card")
            .each(function (index, _) {
                const $cta = $(this);
                const textContent = $cta
                    .find(".latest-offers-cta-label")
                    .text();
                const targetPageLink = $cta.attr("href");

                $cta.click(() => {
                    if (!window.s) {
                        return;
                    }

                    const s = window.s;
                    const prevUseBeacon = s.useBeacon;

                    s.useBeacon = true; // temporarily enable beacon
                    try {
                        triggerCustomAnalytics(window.s, {
                            eVar14: `view offer|${targetPageLink}|${currentPageLink}|Offers Slider`,
                            eVar23: `button-click|view offer`,
                            eVar64: `c${index + 1}_Offer Slider ${
                                index + 1
                            }`,
                        });
                    } catch (error) {
                        console.log(error.message);
                    }
                    s.useBeacon = prevUseBeacon;
                });
            });
    }

    function setupSlideChangeTagging() {
        $slider.on(
            "beforeChange",
            function (_, slick, currentSlide, nextSlide) {
                if (nextSlide === currentSlide) return; // snap-back, no real change
                const sliderTitle = $wrapper
                    .find(".latest-offers-title")
                    .text();

                if (slick.autoplay) return;
                const direction =
                    nextSlide > currentSlide ? "next" : "previous";
                triggerCustomAnalytics(window.s, {
                    eVar23: `Offers Slider|${direction} slide`,
                });
            }
        );

        $slider.on("afterChange", function () {
            updateButtons();
        });
    }

    setTimeout(() => {
        initializeSlick();
        setTimeout(() => {
            bindControls();
            updateButtons();
            setupCtaTagging();
            setupSlideChangeTagging();
        }, 300);
    }, 10);
}

$(function () {
    $(".alt-component-latest-offers").each(function () {
        initLatestOfferSlider($(this));
    });
});
// animated magnite vlp : latest offer slider end

// animated magnite vlp : FAQ Accordian start
$(document)
    .off("click.viewMoreFaq", ".btnViewMoreFaq")
    .on("click.viewMoreFaq", ".btnViewMoreFaq", function () {
        const btn = $(this);
        const section = btn.closest(".alt-component-faqAccordian");
        const hiddenFaqs = section.find(".is-hidden-faq");

        const isExpanded = btn.hasClass("is-expanded");

        if (isExpanded) {
            triggerCustomAnalytics(window.s, {
                eVar23: `faq accordion collapse`,
            });
        } else {
            triggerCustomAnalytics(window.s, {
                eVar23: `faq accordion expand`,
            });
        }

        hiddenFaqs.toggle(!isExpanded);

        btn.toggleClass("is-expanded", !isExpanded);
        btn.find(".faq-btn-text").text(isExpanded ? "View more" : "View less");
    });

document.addEventListener("DOMContentLoaded", () => {
    const accordions = document.querySelectorAll(".accordion");

    accordions.forEach((accordion) => {
        const items = accordion.querySelectorAll(".card.faq-card");
        items.forEach((item) => {
            const header = item.querySelector("button.accItemHead");
            const body = item.querySelector(".accItemBody");

            header.addEventListener("click", () => {
                const isExpanded =
                    header.getAttribute("aria-expanded") === "true";

                const headerText = header.textContent.replace(/\n/g, "").trim();
                if (isExpanded) {
                    triggerCustomAnalytics(window.s, {
                        eVar23: `faq accordion ${headerText} closed`,
                    });
                } else {
                    triggerCustomAnalytics(window.s, {
                        eVar23: `faq accordion ${headerText} opened`,
                    });
                }

                // Close all items in the same accordion
                items.forEach((i) => {
                    i.querySelector("button.accItemHead").setAttribute(
                        "aria-expanded",
                        "false"
                    );
                    i.querySelector(".accItemBody").hidden = true;
                });

                // Toggle clicked item
                if (!isExpanded) {
                    header.setAttribute("aria-expanded", "true");
                    body.hidden = false;
                }
            });
        });
    });

    // hide first accordion by default js
    const firstAccordion = document.querySelector(
        ".alt-component-faqAccordian .faq-card"
    );
    const accBtn = firstAccordion?.querySelector("button.accItemHead");
    accBtn?.setAttribute("aria-expanded", false);
    accBtn?.classList.add("collapsed");

    const accBody = firstAccordion?.querySelector(".accItemBody");
    accBody?.setAttribute("hidden", true);
    accBody?.classList.remove("show");
});

// animated magnite vlp : FAQ Accordian end
/* END OF EXTERNAL MAGNITE VLP */

// ANIMATION LOGIC START
// Select all fade elements
const fadeElements = document.querySelectorAll(
    ".fade-element1, .fade-element2, .fade-element3, .fade-element4, .fade-element5, .fade-element6"
);
function handleScroll() {
    const triggerBottom = window.innerHeight * 0.9; // trigger when element is 90% down the viewport
    fadeElements.forEach((el) => {
        const elementTop = el.getBoundingClientRect().top;
        if (elementTop < triggerBottom) {
            el.classList.add("visible");
        } else {
            el.classList.remove("visible"); // optional: remove if you do not want fade out when scrolling up
        }
    });
}
// Listen for scroll
window.addEventListener("scroll", handleScroll);
// Trigger once on load
handleScroll();

// fix to animate top most component (Hero Image Banner) on page load
function FixHeroImgBannerAnimation() {
    const fadeElementsInHeroImgBanner = document
        .querySelector(".alt-component-heroImageBanner")
        ?.querySelectorAll(
            ".fade-element1, .fade-element2, .fade-element3, .fade-element4, .fade-element5, .fade-element6"
        );
    if (fadeElementsInHeroImgBanner && fadeElementsInHeroImgBanner.length) {
        fadeElementsInHeroImgBanner.forEach((el) => {
            el.classList.add("visible");
            setTimeout(() => {
                el.classList.remove("fade-element1","fade-element2","fade-element3","fade-element4","fade-element5","fade-element6");
            }, 1500);
        });
    }
}

function setupCtaTaggingInHeroImageBanner() {
    const component = document.querySelector(".alt-component-heroImageBanner");
    if (component) {
        const componentHeading =
            component.querySelector(".heading").textContent;
        const primaryCta = component.querySelector(".cta-list a.primary-cta");
        primaryCta?.addEventListener("click", () => {
            const textContent = primaryCta.textContent
                .replace(/\n/g, "")
                .trim();
            if (!window.s) {
                return;
            }

            const s = window.s;
            const prevUseBeacon = s.useBeacon;

            s.useBeacon = true; // temporarily enable beacon
            try {
                triggerCustomAnalytics(window.s, {
                    eVar14: `${textContent}|${primaryCta.href}|${currentPageLink}|hero image banner`,
                    eVar23: `button-click|${textContent?.trim()}`,
                    eVar64: `c1_${componentHeading}`,
                });
            } catch (error) {
                console.log(error.message);
            }
            s.useBeacon = prevUseBeacon;
        });

        const secondaryCta = component.querySelector(
            ".cta-list a.secondary-cta"
        );
        secondaryCta?.addEventListener("click", () => {
            const textContent = secondaryCta.textContent
                .replace(/\n/g, "")
                .trim();
            if (!window.s) {
                return;
            }

            const s = window.s;
            const prevUseBeacon = s.useBeacon;

            s.useBeacon = true; // temporarily enable beacon
            try {
                triggerCustomAnalytics(window.s, {
                    eVar14: `${textContent}|${secondaryCta.href}|${currentPageLink}|hero image banner`,
                    eVar23: `button-click|${textContent?.trim()}`,
                    eVar64: `c2_${componentHeading}`,
                });
            } catch (error) {
                console.log(error.message);
            }
            s.useBeacon = prevUseBeacon;
        });
    }
}

function setupHeroImageBanner() {
    FixHeroImgBannerAnimation();
    setupCtaTaggingInHeroImageBanner();
}
window.addEventListener("DOMContentLoaded", setupHeroImageBanner);

// animated magnite vlp : feature text top and image carousel v2 start
function initFeatureTextTopImageCarouselV2($wrapper) {
    // dont trigger inside backend editor
    if ($(".alt-editor").length) return;
    console.log("wrapper - ", $wrapper);

    const $slider = $wrapper.find(".slides-container");
    const speed = 750;

    const componentName = $wrapper.find(".feature-name").text();

    function initializeSlick() {
        if (!$slider.length) return;

        if (!$slider.hasClass("slick-initialized")) {
            $slider.slick({
                rtl: document.documentElement.lang === 'ar',
                slidesToShow: 2.1,
                slidesToScroll: 1,
                centerMode: false,
                centerPadding: "0",
                arrows: false,
                speed: speed,
                infinite: false,
                accessibility: false,
                adaptiveHeight: false,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        },
                    },
                ],
            });
        }

        // Update buttons after initialization and on every slide change
        $slider.on("afterChange", function () {
            updateButtons();
        });
    }

    function updateButtons() {
        if (!$slider.length) return;

        if (!$slider.hasClass("slick-initialized")) return;

        //INFO: Sometimes slickGetOption can return undefined during early init or resize.
        const slidesToShow =
            $slider.slick("slickGetOption", "slidesToShow") || 1;
        const current = $slider.slick("slickCurrentSlide");
        const total = $slider.find(".slick-slide:not(.slick-cloned)").length;

        $wrapper
            .find(".prev, .prev-mbl")
            .toggleClass("disabled", current === 0);
        $wrapper
            .find(".next, .next-mbl")
            .toggleClass("disabled", current >= total - slidesToShow);
    }

    function bindControls() {
        const safeNext = function () {
            if ($slider.hasClass("slick-initialized")) {
                $slider.slick("slickNext");
                updateButtons();
            }
        };

        const safePrev = function () {
            if ($slider.hasClass("slick-initialized")) {
                $slider.slick("slickPrev");
                updateButtons();
            }
        };

        $wrapper.find(".next").on("click", safeNext);
        $wrapper.find(".prev").on("click", safePrev);
    }

    function setupCtaTagging() {
        const ctaEl = $wrapper.find("a.feature-cta");

        if (ctaEl) {
            const textContent = ctaEl.find(".cta-label").text();
            const targetPageLink = ctaEl.attr("href");
            ctaEl.click(() => {
                if (!window.s) {
                    return;
                }

                const s = window.s;
                const prevUseBeacon = s.useBeacon;

                s.useBeacon = true; // temporarily enable beacon
                try {
                    triggerCustomAnalytics(window.s, {
                        eVar14: `${textContent}|${targetPageLink}|${currentPageLink}|Feature text top and image carousel`,
                        eVar23: `button-click|${textContent} `,
                        eVar64: `c1_${componentName}`,
                    });
                } catch (error) {
                    console.log(error.message);
                }
                s.useBeacon = prevUseBeacon;
            });
        }
    }

    function setupBeforeChangeTagging() {
        $slider.on(
            "beforeChange",
            function (_, slick, currentSlide, nextSlide) {
                if (nextSlide === currentSlide) return; // snap-back, no real change
                const sliderTitle = $wrapper
                    .find(".feature-information .feature-name")
                    .text();

                const direction =
                    nextSlide > currentSlide ? "next" : "previous";
                console.log(`${sliderTitle}|${direction} slide`);
                triggerCustomAnalytics(window.s, {
                    eVar23: `${sliderTitle}|${direction} slide`,
                });
            }
        );
    }

    setTimeout(() => {
        initializeSlick();
        setTimeout(() => {
            bindControls();
            updateButtons();
            setupCtaTagging();
            setupBeforeChangeTagging();
        }, 300);
    }, 10);
}
$(function () {
    $(".alt-component-featureTextImageCarouselV2").each(function () {
        initFeatureTextTopImageCarouselV2($(this));
    });
});
// animated magnite vlp : feature text top and image carousel v2 end

// animated magnite vlp: action panel start
function setupActionPanelTagging() {
    const allPanelsCta = document.querySelectorAll(
        ".alt-component-card-panel a.card-item"
    );
    allPanelsCta?.forEach((ctaEl, idx) => {
        const textContent = ctaEl
            .querySelector(".card-title")
            .textContent.replace(/\n/g, "")
            .trim();
        const targetPageLink = ctaEl.href;
        ctaEl.addEventListener("click", () => {
            if (!window.s) {
                return;
            }

            const s = window.s;
            const prevUseBeacon = s.useBeacon;

            s.useBeacon = true; // temporarily enable beacon
            try {
                triggerCustomAnalytics(window.s, {
                    eVar14: `${textContent}|${targetPageLink}|${currentPageLink}|Action panel`,
                    eVar23: `button-click|${textContent} `,
                    eVar64: `c${idx + 1}_action panel`,
                });
            } catch (error) {
                console.log(error.message);
            }
            s.useBeacon = prevUseBeacon;
        });
    });
}

window.addEventListener("DOMContentLoaded", () => {
    setTimeout(() => {
        setupActionPanelTagging();
    }, 1000);
});

// INFO: Slide-In Animation usage:
// 1- the parent element (not necessarily top-most parent) must have the class .vlp-slider-animation
// 2- the element which you want to animate should have class .slidein-animate
(function () {
    const animatedSlides = new Set();

    function checkSlides() {
        const containers = document.querySelectorAll(".vlp-slider-animation");

        containers.forEach((container, containerIndex) => {
            const rect = container.getBoundingClientRect();
            const windowHeight = window.innerHeight;

            // Calculate if x% of element is visible
            const elementHeight = rect.height;
            const visibleHeight =
                Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);
            const visiblePercentage = visibleHeight / elementHeight;

            // Change 0.x in JS to adjust viewport trigger percentage
            if (visiblePercentage >= 0.4 && rect.top < windowHeight) {
                const slides = container.querySelectorAll(".slidein-animate");

                slides.forEach((slide, index) => {
                    const slideId = `slide-${containerIndex}-${index}`;

                    if (!animatedSlides.has(slideId)) {
                        setTimeout(() => {
                            slide.classList.add("animate-in");
                            animatedSlides.add(slideId);
                        }, index * 350); // change to adjust delay between slides
                    }
                });
            }
        });
    }

    // Check on scroll
    window.addEventListener("scroll", checkSlides);

    // Check on page load
    window.addEventListener("load", checkSlides);

    // Initial check
    if (document.readyState === "complete") {
        checkSlides();
    }
})();
// ANIMATION LOGIC ENDS

// carousel tagging general function
function setupSlideChangeTagging(wrapper, carouselTitle, slider) {
    let lastInteraction = null; // drag | arrow | pagination | programmatic
    let isAutoplay = false;
    let slideDirection = null;
    let fromSlide = null;
    let dragStarted = false; // NEW: track if drag started

    // drag / swipe START
    slider.on("mousedown touchstart", () => {
        dragStarted = true; // Mark that drag started, but don't set lastInteraction yet
    });

    // drag / swipe END - only set if slide actually swiped
    slider.on("swipe", () => {
        if (dragStarted) {
            lastInteraction = "drag"; // Only NOW set it to drag
        }
    });

    // Clear drag flag if mouse/touch released without swiping
    slider.on("mouseup touchend mouseleave touchcancel", () => {
        dragStarted = false;
    });

    // arrow clicks
    // slider.on("click", ".slick-next, .slick-prev", () => {
    //     lastInteraction = "arrow";
    // });

    // pagination
    wrapper.on("click", ".count", (ev) => {
        lastInteraction = "pagination";
    });

    slider.on("beforeChange", (e, slick, current, next) => {
        const total = slick.slideCount;
        fromSlide = current;

        if (slick.options.infinite) {
            if (current === total - 1 && next === 0) {
                slideDirection = "next";
            } else if (current === 0 && next === total - 1) {
                slideDirection = "prev";
            } else {
                slideDirection = next > current ? "next" : "prev";
            }
        } else {
            slideDirection = next > current ? "next" : "prev";
        }
    });

    // after change
    slider.on("afterChange", (e, slick, current) => {
        // If nothing triggered it → autoplay
        isAutoplay = !lastInteraction;

        // Only detect direction if NOT autoplay
        if (!isAutoplay) {
            /* console.log({
                slideIndex: current,
                direction: slideDirection, // next | prev
                source: lastInteraction, // drag | arrow | pagination
            });
            console.log(`${carouselTitle}|${slideDirection}`); */

            // 👉 analytics / logic goes here
            triggerCustomAnalytics(window.s, {
                eVar23: `${carouselTitle}|${slideDirection} slide`,
            });
        }

        // reset state
        lastInteraction = null;
        isAutoplay = false;
        slideDirection = null;
        fromSlide = null;
        dragStarted = false; // Reset drag flag
    });
}

// apply container class on vlp pages
document.addEventListener("DOMContentLoaded", () => {
    document.querySelector("main#container")?.classList.add("vlp-container");
});

// fix for safari not loading svg with filter
document.addEventListener("DOMContentLoaded", () => {
    const isMob = window.matchMedia("(max-width: 600px)").matches;
    if (isMob) {
        const floatingCtaContainerEl = document.querySelector(
            ".alt-component-floatingCtas"
        );
        floatingCtaContainerEl?.querySelector(".desktop").classList.add("hide");
        floatingCtaContainerEl
            ?.querySelector(".mobile")
            .classList.remove("hide");

        floatingCtaContainerEl.querySelector(
            ".cta-list.mobile .svg-button.burger-menu"
        ).innerHTML = `
                <svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
                <rect width="50" height="50" rx="25" fill="#313131" fill-opacity="0.5"/>

                <path
                    d="M17.3334 28.3333V26.3333H33.3334V28.3333H17.3334Z
                    M17.3334 24.3333V22.3333H33.3334V24.3333H17.3334Z"
                    fill="white"
                />
                </svg>
            `;

        floatingCtaContainerEl.querySelector(
            ".cta-list.mobile .svg-button.close-burger-menu"
        ).innerHTML = `
                <svg
                width="50"
                height="50"
                viewBox="0 0 50 50"
                xmlns="http://www.w3.org/2000/svg"
                >
                <!-- background -->
                <rect
                    width="50"
                    height="50"
                    rx="25"
                    fill="#313131"
                    fill-opacity="0.5"
                />

                <!-- close (X) icon -->
                <path
                    d="M19.7333 32.3334
                    L18.3333 30.9334
                    L23.9333 25.3334
                    L18.3333 19.7334
                    L19.7333 18.3334
                    L25.3333 23.9334
                    L30.9333 18.3334
                    L32.3333 19.7334
                    L26.7333 25.3334
                    L32.3333 30.9334
                    L30.9333 32.3334
                    L25.3333 26.7334
                    L19.7333 32.3334
                    Z"
                    fill="white"
                />
                </svg>
            `;
    }
});

window.addEventListener("load", () => {
    if (window.location.hash) {
        const el = document.querySelector(window.location.hash);
        if (el) {
            setTimeout(() => {
                el.scrollIntoView();
            }, 100);
        }
    }
});

window.addEventListener(
    "scroll",
    () => {
        userScrolled = true;
        console.log("userScrolled -> true");
    },
    { once: true }
);

// vehicle colorizer 360 setup start
/**
 * Replaces spaces, forwardslash, backslash etc. with underscore.
 *
 * @param colorname - name of the color with unnecessary characters
 * @returns name of the color with replaced unnecessary characters
 *
 * @example
 * ```
 * input -> Blade_Silver\/ Onyx Black
 * output -> Blade_Silver_Onyx_Black
 * ```
 */
function getColorNameByConvention(colorName) {
    return colorName.replaceAll('\/', '').replaceAll('  ', ' ').replaceAll(' / ', '_').replaceAll(' ', '_').replaceAll('__', '_');
}

function generateImageArray(folderPath, colorName) {
  return Array.from({ length: 36 }, (_, index) => {
    const frame = String(index + 1).padStart(4, "0");
    return `${folderPath}/${colorName}${frame}.png`;
  });
}

class MagniteVehicleColorizer360 {
  constructor() {
    this.render();
    this.allColorExtImages = [];
    this.componentElement = null;
    this.threeSixtyContainer = null;
    this.allColorHotspots = [];
    this.threeSixtyInstance = null;
    this.loaderElement = null;
    this.isLoading = false;
    this.vehicleName = '';
    this.userHasRotated360 = false;
  }

  render() {
    document.addEventListener("DOMContentLoaded", async () => {
      this.componentElement = document.querySelector(
        ".alt-component-colorizer360",
      );
      if (!this.componentElement) {
        return;
      }
      this.threeSixtyContainer = this.componentElement.querySelector(
        "#threesixty-container",
      );
      this.vehicleGrade = this.componentElement.getAttribute('data-grade');
      this.showLoader(this.threeSixtyContainer);
      await this.getVehicleColorSpots();
        console.log('this.allColorExtImages - ',  this.allColorExtImages)
      const firstVehicle = this.allColorExtImages[0];
      const firstVehicleImages = Object.values(firstVehicle)[0];
      const firstVehicleName = Object.keys(firstVehicle)[0];
      await this.initializeThreeSixty(firstVehicleImages);
      await this.setupColorHotspots();
      setTimeout(() => {
        this.manageActiveAndInactiveHotspot(firstVehicleName);
        this.track360Stop();
      }, 1000);
      this.setupCtaTagging();
    });
  }

  async preloadImages(imagesArray) {
    return Promise.all(
      imagesArray.map(
        (src) =>
          new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = resolve;
            img.onerror = reject;
            img.src = src;
          }),
      ),
    );
  }

  /**
   * Probes whether a given image URL loads successfully.
   */
  async imageExists(src) {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => resolve(true);
      img.onerror = () => resolve(false);
      img.src = src;
    });
  }

  /**
   * Returns the valid image set for a color:
   * - All 36 frames if the second frame loads (full 360 sequence)
   * - Only the first frame if only that one loads (static fallback)
   * - null if even the first frame fails (color is broken entirely)
   */
  async resolveValidImages(imagesArray) {
    const firstExists = await this.imageExists(imagesArray[0]);
    if (!firstExists) {
      return null;
    }
    // The second frame is the minimal proof that the full sequence is available.
    // Per the known pattern: either all 36 work or only frame 1 works.
    const secondExists = await this.imageExists(imagesArray[1]);
    return secondExists ? imagesArray : [imagesArray[0]];
  }

  showLoader(container) {
    this.isLoading = true;
    this.hideLoader();
    this.loaderElement = document.createElement("div");
    this.loaderElement.className = "preloader";
    this.loaderElement.innerHTML = `<div class="loader"></div>`;
    container.appendChild(this.loaderElement);
  }

  hideLoader() {
    if (this.loaderElement) {
      this.loaderElement.remove();
      this.loaderElement = null;
    }
    this.isLoading = false;
  }

    async getVehicleColorSpots() {
        const colorSpotsStringified = this.componentElement.getAttribute('data-spots');
        const allColorSpots = JSON.parse(colorSpotsStringified)
        this.allColorHotspots = allColorSpots;
        this.populateExternalImages(allColorSpots);
        // console.log('visible and available color spot: ', allColorSpots)
    }

  async populateExternalImages(colorHotspots) {
    colorHotspots.forEach(color => {
      const colorName = getColorNameByConvention(color.Criteria_label);
      const imagesArray = generateImageArray(color.folder_path, colorName);
      this.allColorExtImages.push({ [colorName]: imagesArray });
    });
  }

  /**
    * Renders the 360 viewer or a static image fallback depending on
    * how many valid frames the color has.
    *
    * @param {string[]} imagesArray - The candidate 36-frame array for this color.
    */
    async initializeThreeSixty(imagesArray) {
      this.showLoader(this.threeSixtyContainer);
      const validImages = await this.resolveValidImages(imagesArray);

      // Full 36-frame sequence available — initialise the 360 viewer normally.
        if (this.threeSixtyInstance) {
          // Destroy the previous instance if the library exposes a teardown method.
            if (typeof this.threeSixtyInstance.destroy === "function") {
              this.threeSixtyInstance.destroy();
            }
          this.threeSixtyInstance = null;
        }

      this.threeSixtyInstance = new window.threesixty(
        this.threeSixtyContainer,
        validImages || [],
      );
      this.threeSixtyInstance.init();
      this.hideLoader();
      this.userHasRotated360 = false;
    }

  /**
   * Inserts a plain <img> into the 360 container as a static fallback
   * when only one frame is available for a color.
   */
  renderStaticFallback(src) {
    const img = document.createElement("img");
    img.src = src;
    img.alt = "";
    img.className = "threesixty-static-fallback";
    img.style.cssText = "width:100%;height:100%;object-fit:contain;display:block;";
    this.threeSixtyContainer.appendChild(img);
  }

  manageActiveAndInactiveHotspot(colorName) {
    // console.log(colorName)
    const hotspotLiElements = this.componentElement.querySelectorAll(
      ".external-colors li",
    );
    hotspotLiElements.forEach((li) => {
      if (li.dataset.color === colorName) {
        li.classList.add("active");
      } else {
        li.classList.remove("active");
      }
    });
  }

  async setupColorHotspots() {
    const hotspotContainer = this.componentElement.querySelector(".external-colors");
    hotspotContainer.innerHTML = "";
    this.allColorHotspots.forEach((color, index) => {
      const colorName = getColorNameByConvention(color.Criteria_label);
        const folderPath = color.folder_path;
      const imageSrc=`${folderPath}/${colorName}.webp`

      const li = document.createElement("li");
      li.dataset.color = colorName;
      li.dataset.imagesIndex = index;
      li.innerHTML = `
        <img src="${imageSrc}">
        <svg class="check-icon" width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.075 17.0354L0 8.96042L2.01875 6.94167L8.075 12.9979L21.0729 0L23.0917 2.01875L8.075 17.0354Z" fill="white"/>
        </svg>
        `;

      li.addEventListener("click", async () => {
        if (li.classList.contains('active') || this.isLoading) {
          return;
        }
        this.showLoader(this.threeSixtyContainer);
        this.manageActiveAndInactiveHotspot(colorName);

        const imagesArray = Object.values(this.allColorExtImages[index])[0];
        await this.initializeThreeSixty(imagesArray);
        this.isLoading = false;

        if (!window.s) {
          return;
        }
        const s = window.s;
        const prevUseBeacon = s.useBeacon;
        s.useBeacon = true;
        try {
          triggerCustomAnalytics(window.s, {
            eVar23: `colorizer color pick | ${colorName}`,
          });
        } catch (error) {
          console.log(error.message);
        }
        s.useBeacon = prevUseBeacon;
      });
      hotspotContainer.append(li);


    });
  }

  setupCtaTagging() {
    const cta = this.componentElement.querySelector("a.cta");
    cta.addEventListener("click", () => {
      const textContent = cta.textContent.trim();
      const targetPageLink = cta.getAttribute("href");
      const componentName = this.componentElement
        .querySelector(".heading")
        .textContent.trim();

      if (!window.s) {
        return;
      }
      const s = window.s;
      const prevUseBeacon = s.useBeacon;
      s.useBeacon = true;
      try {
        triggerCustomAnalytics(window.s, {
          eVar14: `colorizer cta|${targetPageLink}|${currentPageLink}|colorizer`,
          eVar23: `button-click | colorizer cta`,
          eVar64: `c1_colorizer`,
        });
      } catch (error) {
        console.log(error.message);
      }
      s.useBeacon = prevUseBeacon;
    });
  }

  track360Stop() {
    this.threeSixtyContainer.addEventListener("mousedown", () => {
      this.userHasRotated360 = true;
    });

    this.threeSixtyContainer.addEventListener("touchstart", () => {
      this.userHasRotated360 = true;
    });

    
    if (this.frameTrackerInterval) {
      clearInterval(this.frameTrackerInterval);
    }

    let lastFrame = this.threeSixtyInstance.getCurrentFrame();
    let debounceTimer = null;

    this.frameTrackerInterval = setInterval(() => {
      const currentFrame = this.threeSixtyInstance.getCurrentFrame();
      if (currentFrame === lastFrame) {
        return;
      }
      lastFrame = currentFrame;

      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        // Ignore frame changes caused by loading a new color
        if (!this.userHasRotated360) {
          return;
        }

        this.userHasRotated360 = false;
        if (!window.s) return;
        const s = window.s;
        const prevUseBeacon = s.useBeacon;
        s.useBeacon = true;

        try {
          triggerCustomAnalytics(s, {
            eVar23: "exterior | user rotate car",
          });
        } catch (error) {
          console.log(error.message);
        }

        s.useBeacon = prevUseBeacon;
      }, 500); // rotation has stopped for 500ms
    }, 50);
  }
}

const magniteVehicleColorizer360 = new MagniteVehicleColorizer360();

// hero-banner moonthly tooltip
function initPriceTooltip() {
    const btn = document.querySelector(
        ".alt-component-heroImageBanner.vlp-section .asterisk-icon"
    );

    if (!btn) return;

    const wrapper = btn.closest(".price-pm-wrapper");
    const tooltip = wrapper?.querySelector(".tooltip");

    if (!tooltip) return;

    
    btn.addEventListener("click", (e) => {
        e.stopPropagation(); 
        tooltip.classList.toggle("is-active");
    });

    // close on outside click
    document.addEventListener("click", () => {
        tooltip.classList.remove("is-active");
    });
}

if(document.querySelector(".alt-component-heroImageBanner.vlp-section .amount-pm")) {
    initPriceTooltip();
}
